import { useState, useEffect, useCallback, useRef } from "react";
import {
    FiCopy,
    FiRotateCcw,
    FiAlertCircle,
    FiX,
    FiTrendingUp,
    FiTrendingDown,
    FiArchive,
    FiVolume2,
    FiFolder,
    FiChevronRight,
    FiChevronLeft,
    FiBell,
} from "react-icons/fi";
import RobotVideo from "../video/dashboard-robot-showcase-clip.mp4";
import IconSwap from "../images/icon-d-swap.png";
import IconStaking from "../images/icon-d-staking.png";
import IconMarketplace from "../images/icon-d-marketplace.png";
import IconCommunity from "../images/icon-d-community.png";
import IconHistory from "../images/icon-d-history.png";
import Imgtotaldeposit from "../images/total-deposit-img.png"
import Imgtotalstaked from "../images/icon-staking-staked.png"
import Imgclaimable from "../images/icon-staking-claimable.png"
import IconCardsProducts from "../images/icon-cards-products.png"
import ImgCardSample from "../images/card-sample.png"
import { ethers } from "ethers";
import { toast } from "react-hot-toast";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import NextfiIcon from "../images/icon-nextFi-reverse.svg";
import Image01 from "../images/icon-assets-wallet.png";
import Image02 from "../images/icon-performace.png";
import JoinNextfi01 from "../images/img-join-001.png";
import JoinNextfi02 from "../images/img-join-002.png";
import JoinNextfi03 from "../images/img-join-003.png";
import ArrowRight from "../images/arrow-right.png";
import IconPurchaseTicket from "../images/purchase-ticket.png";
import IconRedemption from "../images/icon-redemption.png";
import IconRedemptionReverse from "../images/icon-redemption-reverse.png";
import IconInvestment from "../images/icon-investment.png";
import IconInvestmentReverse from "../images/icon-investment-reverse.png";
import WalletIcon from "../images/tcg-icon-wallet.png";
import DonationIcon from "../images/tcg-icon-donation-nft.png";
import RewardIcon from "../images/tcg-icon-trophy.png";
import ClaimRewardIcon from "../images/tcg-icon-claim-reward.png";
import CommunityIcon from "../images/tcg-icon-community.png";
import GoCommunityIcon from "../images/tcg-icon-go-community.png";
import CommunityDonationFrame from "../images/community-donation-frame.png";
import PokedaoLogo from "../images/pokedoa.png";
import { useWallet } from "../hooks/useWallet";
import { useRPCProvider } from "../hooks/useRPCProvider";
import { CONTRACT_ADDRESSES, CONTRACT_ABIS, API_BASE } from "../constants/index";
import { useTranslation } from "../hooks/useTranslation";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getTokenBySymbol } from "../tokens";

const GET_TOTAL_DEPOSIT_API = `${API_BASE}/publicApi/getTotalDeposit`;
const GET_NFT_DETAILS_API = `${API_BASE}/publicApi/getNftDetails`;
const GET_ANNOUNCEMENT_LIST_API = `${API_BASE}/publicApi/getAnnList`;
const GET_VAULT_CARDS_API = `${API_BASE}/publicApi/nftLibraryList`

function formatUsd(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return "Unlisted";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(num);
};

export default function Dashboard() {
    const { t, language } = useTranslation();
    const navigate = useNavigate();
    const { account, isConnected, connectWallet, isCorrectNetwork, getProvider } = useWallet();
    const { executeWithFailover } = useRPCProvider();

    // Extend dayjs with UTC plugin
    dayjs.extend(utc);

    const [depositAmount, setDepositAmount] = useState("0"); // deposit amount from backend getTotalDeposit
    const [isLoadingGroupSales, setIsLoadingGroupSales] = useState(false);
    const [currentTime, setCurrentTime] = useState(Date.now());
    const [searchParams] = useSearchParams();
    const [showReferralModal, setShowReferralModal] = useState(false);
    const [userROIAndCapLive, setUserROIAndCapLive] = useState(null);
    const [isLoadingUserROIAndCapLive, setIsLoadingUserROIAndCapLive] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingVaultCards, setIsLoadingVaultCards] = useState(false);
    const [cardItems, setCardItems] = useState([]);
    const [totalPages, setTotalPages] = useState(null);
    const [totalVaultPages, setTotalVaultPages] = useState(null);
    const [totalItems, setTotalItems] = useState(0);
    const [totalCurrentValue, setTotalCurrentValue] = useState("0");
    const [page, setPage] = useState(1);

    // Restored state setters removed earlier (required by existing fetch/handler code)
    const [groupSales, setGroupSales] = useState({ level: "S0", amount: "0" });
    const [stakingData, setStakingData] = useState({
        totalStaked: "0.00",
        totalRewards: "0.00",
        combined: "0.00",
        activeStakes: 0,
    });
    const [topDownlines, setTopDownlines] = useState([]);
    const [downlinesActiveCount, setDownlinesActiveCount] = useState(0);
    const [usdtBalance, setUsdtBalance] = useState("0");
    const [userTickets, setUserTickets] = useState([]);
    const [isLoadingTickets, setIsLoadingTickets] = useState(false);
    const [isLoadingUnstake, setIsLoadingUnstake] = useState(false);
    const [isLoadingRestake, setIsLoadingRestake] = useState(false);
    const [isReferralBound, setIsReferralBound] = useState(false);
    const [userStakeRecords, setUserStakeRecords] = useState([]);
    const [isLoadingStakeRecords, setIsLoadingStakeRecords] = useState(false);
    const [isLoadingStaking, setIsLoadingStaking] = useState(false);
    const [isTabSwitching, setIsTabSwitching] = useState(false);
    const [UserPacks, setUserPacks] = useState([]);
    const [pools, setPools] = useState([]);
    const [totalValue, setTotalValue] = useState(null);
    const [announcementList, setAnnouncementList] = useState([]);
    const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
    const [currentAnnIndex, setCurrentAnnIndex] = useState(0);
    const [activeTab, setActiveTab] = useState("avault");
    const [vaultCards, setVaultCards] = useState([]);
    const [vaultPage, setVaultPage] = useState(1);
    const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);

    // Keep a ref to the latest account to avoid stale-closure issues
    const accountRef = useRef(account);
    const isFetchingPoolsRef = useRef(false);

    // Ref to track abort controllers for cancelling ongoing requests
    const abortControllersRef = useRef([]);

    const limit = 10;

    // Sync the ref whenever account changes
    useEffect(() => {
        accountRef.current = account;
    }, [account]);

    let marketplaceUrl;

    if (process.env.REACT_APP_ENV == 'staging') {
        marketplaceUrl = 'https://pokemonmarketplace.madxpanel.com/marketplace';
    } else {
        marketplaceUrl = 'https://buypack.tcg.zone/marketplace';
    }

    // Refs for accessing latest function references in intervals
    const fetchFunctionsRef = useRef();

    const fetchUserROIAndCapLive = useCallback(async () => {
        if (!account || !isConnected || !isCorrectNetwork) {
            return;
        }

        try {
            setIsLoadingUserROIAndCapLive(true);
            const { stakeAmount, confirmedTotal } = await executeWithFailover(async (provider) => {

                const stakingContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.STAKING,
                    CONTRACT_ABIS.STAKING,
                    provider
                );

                const {
                    stakeAmount,
                    confirmedTotal
                } = await stakingContract.getUserROIAndCapLive(account);

                return {
                    stakeAmount: formatBonusAmount(stakeAmount),
                    confirmedTotal: formatBonusAmount(confirmedTotal),
                };
            });

            setUserROIAndCapLive({
                "stakeAmount": stakeAmount,
                "confirmedTotal": confirmedTotal,
            });
            setIsLoadingUserROIAndCapLive(false);
        } catch (error) {
            console.error("Error getting user ROI and cap live:", error);
            toast.error("Error getting user ROI and cap live: " + error.message);
            setUserROIAndCapLive(null);
        }

    }, [account, isConnected, isCorrectNetwork, executeWithFailover]);

    // Fetch group sales data
    const fetchGroupSales = useCallback(async () => {
        const currentAccount = accountRef.current;
        if (!currentAccount || !isConnected) {
            setGroupSales({ level: "S0", amount: "0" });
            return;
        }

        setIsLoadingGroupSales(true);
        try {
            const salesData = await executeWithFailover(async (provider) => {
                const stakingContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.STAKING,
                    CONTRACT_ABIS.STAKING,
                    provider
                );

                // Get team KPI from contract
                const teamKpi = await stakingContract.getTeamKpi(currentAccount);
                const teamInvestValue = Number(teamKpi) / 10 ** 18;
                // Get team total investment value (in USDT)
                // const teamInvestValue =
                //     await stakingContract.teamTotalInvestValue(account);
                // const formattedAmount = ethers.formatUnits(teamInvestValue, 18);
                const amount = parseFloat(teamInvestValue).toFixed(18);
                // console.log(amount);
                // Determine level based on team investment value
                let level = "S1";
                const amountNum = parseFloat(amount);
                if (amountNum >= 100000000) {
                    level = "S9";
                } else if (amountNum >= 50000000) {
                    level = "S8";
                } else if (amountNum >= 10000000) {
                    level = "S7";
                } else if (amountNum >= 5000000) {
                    level = "S6";
                } else if (amountNum >= 1000000) {
                    level = "S5";
                } else if (amountNum >= 500000) {
                    level = "S4";
                } else if (amountNum >= 100000) {
                    level = "S3";
                } else if (amountNum >= 50000) {
                    level = "S2";
                } else if (amountNum >= 10000) {
                    level = "S1";
                } else {
                    level = "S0"; // Default for < 10,000
                }

                return { level, amount };
            });

            // Only update if account hasn't changed
            if (currentAccount === accountRef.current) {
                setGroupSales(salesData);
            }
        } catch (error) {
            console.error("Error fetching group sales:", error);
            setGroupSales({ level: "S0", amount: "0" });
        } finally {
            // Only clear loading if account hasn't changed
            if (currentAccount === accountRef.current) {
                setIsLoadingGroupSales(false);
            }
        }
    }, [isConnected, executeWithFailover]);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(value);
    };

    const getPools = async () => {
        try {
            const poolsResult = await executeWithFailover(async (provider) => {
                const packsContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.PACKS,
                    CONTRACT_ABIS.PACKS,
                    provider
                );

                const poolsResult = await packsContract.getAllPools();

                return poolsResult
            });

            // Convert array to object with poolId as key and duration as value
            const formattedPools = poolsResult.reduce((acc, pool) => {
                // Use poolId as key (convert to number if it's BigNumber)
                const poolId = typeof pool.poolId === 'bigint' ? Number(pool.poolId) : pool.poolId;
                acc[poolId] = { "poolName": pool.category };

                return acc;
            }, {});

            setPools(formattedPools);
        } catch (err) {
            console.warn("Provider not available", err);
        }
    };

    // Fetch pools data on mount
    useEffect(() => {
        getPools()
    }, []);

    const getNftDetails = useCallback(async (token_id, nft_address) => {
        try {
            // Convert BigInt to string/number for JSON serialization
            const tokenIdStr = typeof token_id === 'bigint' ? token_id.toString() : (token_id?.toString ? token_id.toString() : token_id);

            const response = await fetch(GET_NFT_DETAILS_API, {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: JSON.stringify({ token_id: tokenIdStr, nft_address: nft_address }, null, 0),
            });

            const responseData = await response.json();

            if (!response.ok) {
                // Preserve error details in the error object
                const error = new Error(responseData.message || responseData.error || `HTTP error! status: ${response.status}`);
                error.errorCode = responseData.errorCode || response.status;
                error.error = responseData.error || responseData.message;
                throw error;
            }

            const data = responseData.data;

            return data;
        } catch (error) {
            console.error("Error fetching nft details:", error);

            // Check if error is 404, NFT not found, or inactive - don't show toast for these
            const errorMessage = (error.message || error.error || "").toLowerCase();
            const isNotFound = error.errorCode === 404 ||
                errorMessage.includes("nft not found") ||
                errorMessage.includes("not found") ||
                errorMessage.includes("inactive");

            if (!isNotFound) {
                toast.error(t("profile.errors.failedFetchNft"));
            }

            // Return null instead of undefined so the code can handle it properly
            return null;
        }
    }, [API_BASE]);

    const getUserPacks = useCallback(async () => {
        if (!account || Object.keys(pools).length === 0) {
            return;
        }

        try {
            setIsLoading(true);
            const { userPacks, receivedStatusByPool } = await executeWithFailover(async (provider) => {
                const packsContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.PACKS,
                    CONTRACT_ABIS.PACKS,
                    provider
                );

                const packs = await packsContract.getUserAllOrders(account);

                return { userPacks: packs[1], receivedStatusByPool: packs[2] }
            });

            // Flatten all pack items into a single array
            const allItems = [];
            userPacks.forEach((pack, index) => {
                const receivedStatusPools = receivedStatusByPool[index];

                pack.forEach((packItem, itemIndex) => {
                    const receivedStatus = receivedStatusPools[itemIndex];
                    // Only return pack data if not bought back
                    if (receivedStatus) {
                        allItems.push({
                            packItem,
                            receivedStatus
                        });
                    }
                });
            });

            // Set total items and total pages for pagination
            setTotalItems(allItems.length);
            setTotalPages(Math.ceil(allItems.length / limit));

            // Sort logic (reverse so newest is first)
            allItems.reverse();

            // Calculate pagination offset
            const offset = (page - 1) * limit;
            const paginatedItems = allItems.slice(offset, offset + limit);

            // Collect promises ONLY for the current page
            const packPromises = paginatedItems.map(async ({ packItem, receivedStatus }) => {
                // Get poolId and convert to number if it's BigNumber
                const poolId = typeof packItem.poolId === 'bigint' ? Number(packItem.poolId) : packItem.poolId;
                const poolData = pools[poolId];
                const poolName = poolData?.poolName || "";

                // Convert poolOrderId to number if it's BigNumber
                const poolOrderId = typeof packItem.poolOrderId === 'bigint' ? Number(packItem.poolOrderId) : packItem.poolOrderId;

                // Wait for NFT details to be fetched
                const nftDetails = await getNftDetails(packItem.tokenId, packItem.nftContract);

                return {
                    tokenId: packItem.tokenId,
                    image: nftDetails?.nm_image2,
                    name: nftDetails?.nm_name,
                    set: nftDetails?.nm_remark || "Sword & Shield",
                    price: parseFloat(nftDetails?.nm_value),
                    fmv: formatCurrency(nftDetails?.nm_value || 45.50),
                    packType: poolName + " Pack",
                    poolOrderId: poolOrderId,
                    nftAddress: packItem.nftContract,
                    buybackValue: nftDetails?.nm_buy_back_value ? new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }).format(nftDetails.nm_buy_back_value) : formatCurrency(0),
                    buybackPercentage: nftDetails?.nm_buy_back_percent ? parseFloat(nftDetails.nm_buy_back_percent).toFixed(2) : null,
                };
            });

            // Wait for all promises to resolve, then filter out null values
            const packResults = await Promise.all(packPromises);
            const userPacksData = packResults.filter(pack => pack !== null);

            // Calculate total value of the paginated packs
            const totalValue = userPacksData.reduce((acc, pack) => acc + (pack.price || 0), 0);
            setTotalValue(totalValue);

            setUserPacks(userPacksData);
            setIsLoading(false);
        } catch (error) {
            console.error("Error getting user packs:", error);
            setIsLoading(false);
        }
    }, [pools, account, page, limit, getNftDetails, executeWithFailover]);

    // Fetch user packs data on mount
    useEffect(() => {
        getUserPacks();
    }, [getUserPacks]);

    // Format Bonus amount (18 decimals) for display
    const formatBonusAmount = useCallback((val) => {
        if (val == null) return "0.00";
        const raw = typeof val === "bigint" ? val.toString() : (val?.toString?.() ?? String(val ?? "0"));
        const parsed = parseFloat(raw);
        if (Number.isNaN(parsed)) return "0.00";
        return (parsed / 1e18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }, []);

    // Fetch top 3 direct downlines by sales (Referral + Bonus contracts, same as Community)
    const fetchTopDownlines = useCallback(async () => {
        const currentAccount = accountRef.current;
        if (!currentAccount || !executeWithFailover) {
            setTopDownlines([]);
            setDownlinesActiveCount(0);
            return;
        }
        try {
            const { addresses, monthIdx } = await executeWithFailover(async (provider) => {
                const referralContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.Referrals,
                    CONTRACT_ABIS.REFERRAL,
                    provider
                );
                const bonusContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.Bonus,
                    CONTRACT_ABIS.BONUS,
                    provider
                );
                const count = await referralContract.getReferredUserCount(currentAccount);
                const n = typeof count === "bigint" ? Number(count) : (count?.toNumber?.() ?? Number(count)) || 0;
                const addrs = [];
                const ZERO = "0x0000000000000000000000000000000000000000";
                for (let i = 0; i < n; i++) {
                    const addr = await referralContract.referredUsers(currentAccount, i);
                    const a = addr && typeof addr === "string" ? addr : (addr?.toString?.() || String(addr));
                    if (a && a.toLowerCase() !== ZERO.toLowerCase()) addrs.push(a);
                }
                const mi = await bonusContract.getCurrentMonthIndex().catch(() => 0);
                const monthIdx = typeof mi === "bigint" ? Number(mi) : (mi?.toNumber?.() ?? Number(mi)) ?? 0;
                return { addresses: addrs, monthIdx };
            });
            if (currentAccount !== accountRef.current) return;

            const withSales = await Promise.all(
                (addresses || []).map(async (addr) => {
                    let personalSales = 0n;
                    let groupSalesVal = 0n;
                    try {
                        const [ps, gs] = await executeWithFailover(async (provider) => {
                            const bonusContract = new ethers.Contract(
                                CONTRACT_ADDRESSES.Bonus,
                                CONTRACT_ABIS.BONUS,
                                provider
                            );
                            const [p, g] = await Promise.all([
                                bonusContract.getPersonalSales(addr, monthIdx),
                                bonusContract.getGroupSales(addr, monthIdx),
                            ]);
                            return [p, g];
                        });
                        personalSales = ps ?? 0n;
                        groupSalesVal = gs ?? 0n;
                    } catch (_) { }
                    const pStr = formatBonusAmount(personalSales);
                    const gStr = formatBonusAmount(groupSalesVal);
                    const sum = parseFloat(pStr.replace(/,/g, "")) + parseFloat(gStr.replace(/,/g, ""));
                    return {
                        address: addr,
                        displayName: `${addr.slice(0, 6)}...${addr.slice(-4)}`,
                        contribution: sum.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        sumNum: sum,
                        active: sum > 0,
                    };
                })
            );
            if (currentAccount !== accountRef.current) return;

            const sorted = withSales.sort((a, b) => b.sumNum - a.sumNum);
            const top3 = sorted.slice(0, 3);
            const activeCount = sorted.filter((m) => m.sumNum > 0).length;

            setTopDownlines(top3);
            setDownlinesActiveCount(activeCount);
        } catch (e) {
            if (e?.code !== "CALL_EXCEPTION" && !e?.message?.includes("Wallet not detected")) {
                console.warn("fetchTopDownlines failed:", e);
            }
            setTopDownlines([]);
            setDownlinesActiveCount(0);
        }
    }, [isConnected, executeWithFailover, formatBonusAmount]);

    // Fetch USDT balance
    const fetchUsdtBalance = useCallback(async () => {
        const currentAccount = accountRef.current;
        if (!currentAccount || !isConnected) {
            setUsdtBalance("0");
            return;
        }

        try {
            const usdtToken = getTokenBySymbol("USDT");
            const balance = await executeWithFailover(async (provider) => {
                const contract = new ethers.Contract(
                    CONTRACT_ADDRESSES.USDT,
                    CONTRACT_ABIS.USDT,
                    provider
                );

                const balanceResult = await contract.balanceOf(currentAccount);
                const formattedBalance = ethers.formatUnits(
                    balanceResult,
                    usdtToken.decimals
                );
                return parseFloat(formattedBalance).toFixed(2);
            });

            if (currentAccount === accountRef.current) {
                setUsdtBalance(balance);
            }
        } catch (error) {
            console.error("Error fetching USDT balance:", error);
            if (currentAccount === accountRef.current) {
                setUsdtBalance("0");
            }
        }
    }, [isConnected, executeWithFailover]);

    // Fetch deposit amount from staking API (same as Staking page) for Total Balance card
    const fetchDepositAmountFromApi = useCallback(async () => {
        const currentAccount = accountRef.current;
        if (!currentAccount) {
            setDepositAmount(null);
            return;
        }
        try {
            const res = await fetch(GET_TOTAL_DEPOSIT_API, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userAddress: currentAccount }),
            });
            const data = await res.json().catch(() => ({}));
            if (currentAccount !== accountRef.current) return;
            if (res.ok && data != null) {
                const bal = data.total_deposit ?? "0.00";
                setDepositAmount(bal != null ? String(bal) : null);
            } else {
                setDepositAmount(null);
            }
        } catch (e) {
            if (accountRef.current === currentAccount) setDepositAmount(null);
        }
    }, []);

    // Fetch group sales data

    // Fetch user tickets
    const fetchUserTickets = useCallback(async () => {
        const currentAccount = accountRef.current;
        if (!currentAccount || !isConnected) {
            setUserTickets([]);
            return;
        }

        setIsLoadingTickets(true);
        try {
            const tickets = await executeWithFailover(async (provider) => {
                const ticketContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.TICKETING,
                    CONTRACT_ABIS.TICKET,
                    provider
                );

                // Get user's tickets
                const ticketsResult = await ticketContract.getUsersTickets(
                    currentAccount
                );

                // Format tickets data and sort by latest ID first
                return ticketsResult
                    .map((ticket) => ({
                        id: Number(ticket.id),
                        validDay: Number(ticket.validDay),
                        owner: ticket.owner,
                        used: ticket.used,
                    }))
                    .sort((a, b) => b.id - a.id); // Sort by ID descending (latest first)
            });

            // Only update if account hasn't changed
            if (currentAccount === accountRef.current) {
                setUserTickets(tickets);
            }
        } catch (error) {
            console.error("Error fetching user tickets:", error);
            setUserTickets([]);
        } finally {
            // Only clear loading if account hasn't changed
            if (currentAccount === accountRef.current) {
                setIsLoadingTickets(false);
            }
        }
    }, [isConnected, executeWithFailover]);

    // Convert day index to date (returns UTC time)
    const dayIndexToDate = (dayIndex) => {
        const dayIndexNum = parseInt(dayIndex);

        // If validDay is already a timestamp (large number), use it directly
        if (dayIndexNum > 1000000000) {
            return dayjs.unix(dayIndexNum).utc();
        }

        // If it's a small number, treat it as days since epoch
        return dayjs.unix(dayIndexNum * 86400).utc();
    };

    // Get validity period (start and end dates) for a ticket
    const getValidityPeriod = (ticket) => {
        if (ticket.validDay) {
            const validDate = dayIndexToDate(ticket.validDay);
            // Convert to UTC+0
            // Ticket is valid from 8:00 AM on start day to 8:00 AM on next day (24 hours)
            const validDateUTC = validDate.utc();
            const startTime = validDateUTC.hour(8).minute(0).second(0); // 8:00 AM UTC
            const endTime = validDateUTC
                .add(1, "day")
                .hour(8)
                .minute(0)
                .second(0); // Next day 8:00 AM UTC

            return {
                start: startTime,
                end: endTime,
                formatted: {
                    start: startTime.utc().format("DD/MM/YY - hh:mm A"),
                    end: endTime.utc().format("DD/MM/YY - hh:mm A"),
                },
            };
        }
        return null;
    };

    // // Check if ticket is expired
    // const isTicketExpired = (ticket) => {
    //     if (ticket.validDay) {
    //         const validityPeriod = getValidityPeriod(ticket);
    //         if (validityPeriod) {
    //             const now = dayjs().utc(); // Current time in UTC+0
    //             // Ticket expires if current time is after the end time (8:00 AM next day UTC)
    //             return now.isAfter(validityPeriod.end);
    //         }
    //     }
    //     return false;
    // };

    // // // Fetch user stake records
    // // const fetchUserStakeRecords = useCallback(async () => {
    // //     const currentAccount = accountRef.current;
    // //     if (!currentAccount || !isConnected) {
    // //         setUserStakeRecords([]);
    // //         return;
    // //     }

    // //     setIsLoadingStakeRecords(true);
    // //     try {
    // //         // Fetch stake count first
    // //         const totalStakes = await executeWithFailover(async (provider) => {
    // //             const stakingContract = new ethers.Contract(
    // //                 CONTRACT_ADDRESSES.STAKING,
    // //                 CONTRACT_ABIS.STAKING,
    // //                 provider
    // //             );
    // //             const stakeCountResult = await stakingContract.stakeCount(currentAccount);
    // //             return Number(stakeCountResult);
    // //         });

    // //         const stakeRecords = [];
    // //         const BATCH_SIZE = 10; // Process 10 stakes at a time

    // //         // Process stakes in batches to avoid timeout
    // //         for (let batchStart = 0; batchStart < totalStakes; batchStart += BATCH_SIZE) {
    // //             // Check if account changed during batch processing
    // //             if (currentAccount !== accountRef.current) {
    // //                 console.log("Account changed during stake record fetching, aborting");
    // //                 return;
    // //             }

    // //             const batchEnd = Math.min(batchStart + BATCH_SIZE, totalStakes);
    // //             const batchPromises = [];

    // //             // Create promises for this batch
    // //             for (let i = batchStart; i < batchEnd; i++) {
    // //                 const promise = executeWithFailover(async (provider) => {
    // //                     const stakingContract = new ethers.Contract(
    // //                         CONTRACT_ADDRESSES.STAKING,
    // //                         CONTRACT_ABIS.STAKING,
    // //                         provider
    // //                     );

    // //                     try {
    // //                         const stakeRecord = await stakingContract.userStakeRecord(currentAccount, i);
    // //                         const stakeTime = Number(stakeRecord[0]);
    // //                         const amount = stakeRecord[1];
    // //                         const status = stakeRecord[2];
    // //                         const stakeIndex = stakeRecord[3];
    // //                         const formattedAmount = ethers.formatUnits(amount, 18);

    // //                         // Get reward for this stake
    // //                         let reward = "0";
    // //                         try {
    // //                             const rewardResult = await stakingContract.rewardOfSlot(currentAccount, i);
    // //                             reward = ethers.formatUnits(rewardResult, 18);
    // //                         } catch (error) {
    // //                             console.warn(`Could not fetch reward for stake ${i}:`, error);
    // //                         }

    // //                         return {
    // //                             index: i,
    // //                             stakeTime,
    // //                             amount: parseFloat(formattedAmount).toFixed(2),
    // //                             status,
    // //                             stakeIndex: Number(stakeIndex),
    // //                             reward: parseFloat(reward).toFixed(2),
    // //                         };
    // //                     } catch (error) {
    // //                         console.warn(`Could not fetch stake record ${i}:`, error);
    // //                         return null;
    // //                     }
    // //                 });

    // //                 batchPromises.push(promise);
    // //             }

    // //             // Wait for this batch to complete
    // //             const batchResults = await Promise.all(batchPromises);

    // //             // Filter out null results and add to stakeRecords
    // //             stakeRecords.push(...batchResults.filter(record => record !== null));

    // //             // Update UI with partial results after each batch
    // //             if (currentAccount === accountRef.current && stakeRecords.length > 0) {
    // //                 setUserStakeRecords([...stakeRecords].sort((a, b) => b.stakeTime - a.stakeTime));
    // //             }
    // //         }

    // //         // Final update with sorted results
    // //         if (currentAccount === accountRef.current) {
    // //             setUserStakeRecords(stakeRecords.sort((a, b) => b.stakeTime - a.stakeTime));
    // //         }
    // //     } catch (error) {
    // //         console.error("Error fetching user stake records:", error);
    // //         setUserStakeRecords([]);
    // //     } finally {
    // //         // Only clear loading if account hasn't changed
    // //         if (currentAccount === accountRef.current) {
    // //             setIsLoadingStakeRecords(false);
    // //         }
    // //     }
    // // }, [isConnected, executeWithFailover]);

    // // Stake days options with rates

    // const getStakeDaysOptions = () => [
    //     { days: 1, rate: 0.3, label: "1 Days - 0.3%", index: 0 },
    //     { days: 7, rate: 1.0, label: "7 Days - 1%", index: 1 },
    //     { days: 30, rate: 1.5, label: "30 Days - 1.5%", index: 2 },
    // ];

    // Fetch referral binding status via Referral contract
    const fetchReferralBindingStatus = useCallback(async () => {
        const currentAccount = accountRef.current;
        if (!currentAccount || !isConnected) {
            setIsReferralBound(false);
            return;
        }

        try {
            const isBound = await executeWithFailover(async (provider) => {
                const referralContract = new ethers.Contract(
                    CONTRACT_ADDRESSES.REFERRALS,
                    CONTRACT_ABIS.REFERRALS,
                    provider
                );
                const result = await referralContract.isBindReferral(currentAccount);
                return result;
            });

            if (currentAccount === accountRef.current) {
                setIsReferralBound(isBound);
            }
        } catch (error) {
            console.error("Error fetching referral binding status:", error);
            setIsReferralBound(false);
        }
    }, [isConnected, executeWithFailover]);

    // Generate referral link. Accepts an optional address to avoid relying on stale state.
    const getReferralLink = (addr) => {
        const refAddress = addr || accountRef.current;
        if (!refAddress) return "";
        const baseUrl = window.location.origin;
        return `${baseUrl}/dashboard?ref=${refAddress}`;
    };

    // Get wallet address for display
    // const getDisplayAddress = () => {
    //     if (!account) return "";
    //     return account;
    // };

    // // Copy referral link to clipboard (robust against timing/stale-account issues)
    // const copyReferralLink = async () => {
    //     // Ensure we have a current account. If not, attempt to connect and wait briefly.
    //     if (!accountRef.current) {
    //         const connected = await connectWallet();
    //         if (!connected) return; // user cancelled or connection failed

    //         // Wait up to 5s for accountRef to populate (polling)
    //         const start = Date.now();
    //         while (!accountRef.current && Date.now() - start < 5000) {
    //             // small delay
    //             // eslint-disable-next-line no-await-in-loop
    //             await new Promise((r) => setTimeout(r, 100));
    //         }

    //         if (!accountRef.current) {
    //             toast.error(t("dashboard.referralLinkUnavailable"));
    //             return;
    //         }
    //     }

    //     const link = getReferralLink(accountRef.current);
    //     if (!link) return;

    //     try {
    //         if (navigator.clipboard && navigator.clipboard.writeText) {
    //             await navigator.clipboard.writeText(link);
    //             toast.success(t("dashboard.referralLinkCopied"));
    //         } else {
    //             // Fallback: show prompt for manual copy
    //             prompt(t("header.copyFailed"), link);
    //         }
    //     } catch (err) {
    //         console.error("Failed to copy referral link:", err);
    //         // Final fallback
    //         try {
    //             prompt(t("header.copyFailed"), link);
    //         } catch (e) {
    //             // ignore
    //         }
    //     }
    // };

    // Clear all data immediately when account changes (runs FIRST)
    useEffect(() => {
        // Cancel any ongoing fetch operations
        abortControllersRef.current.forEach(controller => {
            try {
                controller.abort();
            } catch (e) {
                // Ignore abort errors
            }
        });
        abortControllersRef.current = [];

        // Clear all state immediately to prevent showing previous account's data
        setUserTickets([]);
        setUserStakeRecords([]);
        setStakingData({
            totalStaked: "0.00000",
            totalRewards: "0.00000",
            combined: "0.00000",
            activeStakes: 0,
        });
        setGroupSales({ level: "S0", amount: "0" });
        setIsReferralBound(false);

        // Reset loading states to show fresh loading indicators
        setIsLoadingTickets(false);
        setIsLoadingStakeRecords(false);
        setIsLoadingStaking(false);
        setUsdtBalance("0");
        setIsLoadingGroupSales(false);
        setTopDownlines([]);
        setDownlinesActiveCount(0);
        setDepositAmount(null);
    }, [account]); // Only depends on account - runs immediately when account changes

    // Load staking data, group sales, tickets, stake records, and referral status (runs SECOND)
    useEffect(() => {
        if (accountRef.current && isConnected) {
            // Small delay to ensure state is cleared first
            const timer = setTimeout(() => {
                // fetchStakingData();
                fetchGroupSales();
                fetchTopDownlines();
                fetchUserTickets();
                fetchReferralBindingStatus();
                fetchUsdtBalance();
                fetchDepositAmountFromApi();
                fetchUserROIAndCapLive();
            }, 100); // 100ms delay ensures state clearing happens first

            return () => clearTimeout(timer);
        }
    }, [
        isConnected,
        // fetchStakingData,
        fetchGroupSales,
        fetchTopDownlines,
        fetchUserTickets,
        fetchDepositAmountFromApi,
        fetchUserROIAndCapLive,
        fetchReferralBindingStatus,
        fetchUsdtBalance,
    ]);

    // Keep function references updated
    useEffect(() => {
        fetchFunctionsRef.current = {
            // fetchStakingData,
            fetchGroupSales,
            fetchUsdtBalance,
            fetchUserROIAndCapLive,
            isLoadingUserROIAndCapLive,
            isLoadingGroupSales,
        };
    });

    // Store referral address from URL to localStorage (before wallet connection)
    useEffect(() => {
        const refAddress = searchParams.get("ref");

        if (refAddress && ethers.isAddress(refAddress)) {
            // Store referral address in localStorage for later use
            localStorage.setItem("pendingReferralAddress", refAddress);
        }
    }, [searchParams]);

    // Update current time every minute for countdown
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now());
        }, 60000); // Update every minute

        return () => clearInterval(interval);
    }, []);

    // Auto-refresh staking data and group sales every 5 seconds
    useEffect(() => {
        if (!accountRef.current || !isConnected) return;

        let isMounted = true; // Track component mount status
        let refreshInterval;
        let consecutiveErrors = 0;
        const maxErrors = 3;
        const currentAccountAtStart = accountRef.current;

        const safeRefresh = async () => {
            // Check if component is still mounted and account hasn't changed
            if (!isMounted || currentAccountAtStart !== accountRef.current) return;

            const {
                fetchStakingData: currentFetchStaking,
                fetchGroupSales: currentFetchGroupSales,
                fetchUsdtBalance: currentFetchUsdtBalance,
                fetchUserROIAndCapLive: currentFetchUserROIAndCapLive,
                isLoadingStaking: currentLoadingStaking,
                isLoadingGroupSales: currentLoadingGroupSales,
            } = fetchFunctionsRef.current || {};

            // Skip if already loading or too many consecutive errors or functions not available
            if (
                currentLoadingStaking ||
                currentLoadingGroupSales ||
                consecutiveErrors >= maxErrors ||
                !currentFetchStaking ||
                !currentFetchGroupSales ||
                !currentFetchUsdtBalance ||
                !currentFetchUserROIAndCapLive
            ) {
                return;
            }

            try {
                // Use current function references to avoid stale closures
                await Promise.all([
                    currentFetchStaking(),
                    currentFetchGroupSales(),
                    currentFetchUsdtBalance(),
                    currentFetchUserROIAndCapLive(),
                ]);
                consecutiveErrors = 0; // Reset error counter on success
            } catch (error) {
                consecutiveErrors++;
                console.warn(
                    `Auto-refresh error (${consecutiveErrors}/${maxErrors}):`,
                    error
                );

                // Stop auto-refresh after max errors to prevent spam
                if (consecutiveErrors >= maxErrors) {
                    console.warn(
                        "Auto-refresh disabled due to consecutive errors"
                    );
                    if (refreshInterval) {
                        clearInterval(refreshInterval);
                    }
                }
            }
        };

        // Start interval
        refreshInterval = setInterval(safeRefresh, 5000);

        // Cleanup function
        return () => {
            isMounted = false;
            if (refreshInterval) {
                clearInterval(refreshInterval);
            }
        };
    }, [isConnected]); // Removed account and function dependencies - using accountRef instead

    // Handle tab switch with loading
    // const handleTabSwitch = (tab) => {
    //     setIsTabSwitching(true);
    //     setActiveTab(tab);
    //     // Simulate brief loading for smooth transition
    //     setTimeout(() => {
    //         setIsTabSwitching(false);
    //     }, 300);
    // };

    // const promptReferralLink = async () => {
    //     setShowReferralModal(true);
    // };

    const localizeAnnouncement = useCallback((item) => {
        let title = item.ann_title_en_US;
        let content = item.ann_content_en_US;
        let file = item.ann_file_en_US;

        switch (language) {
            case "zh":
                title = item.ann_title_zh_CN || title;
                content = item.ann_content_zh_CN || content;
                file = item.ann_file_zh_CN || file;
                break;
            case "zh-TW":
                title = item.ann_title_zh_TW || title;
                content = item.ann_content_zh_TW || content;
                file = item.ann_file_zh_TW || file;
                break;
            case "ko":
                title = item.ann_title_ko_KR || title;
                content = item.ann_content_ko_KR || content;
                file = item.ann_file_ko_KR || file;
                break;
            case "ja":
                title = item.ann_title_ja_JP || title;
                content = item.ann_content_ja_JP || content;
                file = item.ann_file_ja_JP || file;
                break;
            case "vi":
                title = item.ann_title_vi_VN || title;
                content = item.ann_content_vi_VN || content;
                file = item.ann_file_vi_VN || file;
                break;
            case "id":
                title = item.ann_title_id_ID || title;
                content = item.ann_content_id_ID || content;
                file = item.ann_file_id_ID || file;
                break;
            case "ta":
                title = item.ann_title_ta_IN || title;
                content = item.ann_content_ta_IN || content;
                file = item.ann_file_ta_IN || file;
                break;
            case "hi":
                title = item.ann_title_hi_IN || title;
                content = item.ann_content_hi_IN || content;
                file = item.ann_file_hi_IN || file;
                break;
            default:
                break;
        }

        return {
            ann_id: item.ann_id,
            ann_title: title || "Announcement",
            ann_content: content || "",
            ann_file: file || null,
            ann_cdate: item.ann_cdate,
            ann_pdate: item.ann_pdate,
        };
    }, [language]);

    const getAnnouncementList = useCallback(async () => {
        try {
            const res = await fetch(GET_ANNOUNCEMENT_LIST_API, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
            });
            const responseData = await res.json().catch(() => ({}));

            if (!res.ok) {
                throw new Error(responseData.message || responseData.error || `HTTP error! status: ${res.status}`);
            }

            const todayDate = new Date().toISOString().split("T")[0];

            const activeAnnouncements = (responseData.data || [])
                .filter((item) => {
                    const announcementDate = new Date(item.ann_pdate).toISOString().split("T")[0];
                    return item.ann_login_display === "show" && announcementDate <= todayDate;
                })
                .map(localizeAnnouncement);

            setAnnouncementList(activeAnnouncements);
            setCurrentAnnouncementIndex(0);

            if (activeAnnouncements.length > 0) {
                const sessionKey = `pokemon-dashboard-announcement-${activeAnnouncements.map((item) => item.ann_id || item.ann_pdate).join("-")}`;
                const hasSeenInSession = sessionStorage.getItem(sessionKey) === "1";
                setShowAnnouncementModal(true);
                sessionStorage.setItem(sessionKey, "1");
                // if (!hasSeenInSession) {
                //     setShowAnnouncementModal(true);
                //     sessionStorage.setItem(sessionKey, "1");
                // }
            }
        } catch (error) {
            console.error("Error getting announcement list:", error);
        }
    }, [localizeAnnouncement]);

    useEffect(() => {
        getAnnouncementList();
    }, [getAnnouncementList]);

    const currentAnnouncement = announcementList[currentAnnouncementIndex];

    const showPreviousAnnouncement = () => {
        setCurrentAnnouncementIndex((prev) =>
            prev === 0 ? announcementList.length - 1 : prev - 1
        );
    };

    const showNextAnnouncement = () => {
        setCurrentAnnouncementIndex((prev) =>
            prev === announcementList.length - 1 ? 0 : prev + 1
        );
    };

    const closeReferralModal = async () => {
        setShowReferralModal(false);
    };

    const copyFromModal = async () => {
        const input = document.querySelector(".referral-link");
        input.focus();
        input.select();
        document.execCommand("copy");
        toast.success(t("dashboard.referralLinkCopied"));
    };

    const fetchVaultCards = useCallback(async () => {
        setIsLoadingVaultCards(true);
        try {
            const response = await fetch(GET_VAULT_CARDS_API, {
                method: "POST",
                headers: { Accept: "application/json" },
                body: JSON.stringify({ limit, page: vaultPage }),
            });
            const data = await response.json();
            if (!response.ok || !data.success) throw new Error(data.message || "Failed to fetch vault cards");
            const sorted = (data.data || []).slice().sort((a, b) => {
                const dateA = new Date(a.nl_cdate.replace(' ', 'T'));
                const dateB = new Date(b.nl_cdate.replace(' ', 'T'));
                return dateA - dateB;
            });

            sorted.forEach((item) => {
                const price_changes = parseFloat(item.nl_value) - parseFloat(item.nl_last_value);
                item.isPositive = price_changes >= 0;
                item.price_changes = price_changes;
                item.price_change_percent = (price_changes / parseFloat(item.nl_value)) * 100;

                let name = item.nl_name;
                let remark = item.nl_remark;
                switch (language) {
                    case 'zh': name = item.nl_name_zh_CN || name; remark = item.nl_remark_zh_CN || remark; break;
                    case 'zh-TW': name = item.nl_name_zh_TW || name; remark = item.nl_remark_zh_TW || remark; break;
                    case 'ko': name = item.nl_name_ko_KR || name; remark = item.nl_remark_ko_KR || remark; break;
                    case 'ja': name = item.nl_name_ja_JP || name; remark = item.nl_remark_ja_JP || remark; break;
                    case 'vi': name = item.nl_name_vi_VN || name; remark = item.nl_remark_vi_VN || remark; break;
                    case 'id': name = item.nl_name_id_ID || name; remark = item.nl_remark_id_ID || remark; break;
                    case 'ta': name = item.nl_name_ta_IN || name; remark = item.nl_remark_ta_IN || remark; break;
                    case 'hi': name = item.nl_name_hi_IN || name; remark = item.nl_remark_hi_IN || remark; break;
                    default: break;
                }
                item.nl_name = name;
                item.nl_remark = remark;

            });

            setVaultCards(sorted);
            setTotalVaultPages(data.total_pages);
            setTotalItems(data.total);
            setTotalCurrentValue(data.total_current_value);
        } catch (error) {
            console.error("Error fetching vault cards:", error);
            setVaultCards([]);
            setTotalVaultPages(null);
        } finally {
            setIsLoadingVaultCards(false);
        }
    }, [vaultPage, language]);

    useEffect(() => {
        fetchVaultCards();
    }, [fetchVaultCards]);

    return (
        <div className="relative overflow-x-hidden -mx-4 min-h-[calc(100vh-200px)]">
            {/* ── Hero Section ── */}
            <div className="relative z-10 max-w-[550px] mx-auto overflow-hidden">
                {/* Robot Video */}
                <div className="relative w-full" style={{ paddingBottom: '100%' }}>
                    <video
                        src={RobotVideo}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="absolute inset-0 w-full h-full object-cover"
                        style={{ mixBlendMode: 'lighten' }}
                    />
                    {/* Bottom fade overlay */}
                    <div
                        className="absolute bottom-0 left-0 right-0"
                        style={{ height: '45%', background: 'linear-gradient(#00000000, rgb(0 0 0) 80%)' }}
                    />
                </div>

                {/* Amount + subtitle */}
                <div className="relative z-10 text-center px-4 -mt-16 pb-6">
                    <p
                        className="font-extrabold leading-none tracking-tight"
                        style={{
                            fontSize: 'clamp(2.2rem, 9vw, 3.4rem)',
                            background: 'linear-gradient(135deg, #c084fc 0%, #a855f7 40%, #7c3aed 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            textShadow: 'none',
                            filter: 'drop-shadow(0 0 24px rgba(168,85,247,0.45))',
                        }}
                    >
                        ${(() => {
                            const value = Number(totalCurrentValue);
                            return Number.isFinite(value) ? value : 0;
                        })().toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </p>
                    <p className="mt-2 text-white/70 text-sm font-medium tracking-wide">
                        {t("dashboard.assetUnderManagement") || "Asset Under Management"}
                    </p>
                </div>

                {/* Bottom quick-action icons */}
                {/* <div className="relative z-10 flex items-start justify-around px-4 pb-8 pt-2">
                    {[
                        { img: IconSwap, label: t("swap.title"), onClick: () => navigate("/swap") },
                        { img: IconStaking, label: t("staking.title"), onClick: () => navigate("/staking") },
                        { img: IconMarketplace, label: t("marketplace.title"), onClick: () => { window.open(marketplaceUrl, '_blank') } },
                        { img: IconCommunity, label: t("community.title"), onClick: () => navigate("/community") },
                        { img: IconHistory, label: t("general.history"), onClick: () => navigate("/history") },
                    ].map(({ img, label, onClick }) => (
                        <button
                            key={label}
                            type="button"
                            onClick={onClick}
                            className="flex flex-col items-center gap-2 group"
                        >
                            <span
                                className="flex items-center justify-center size-14 rounded-full border border-[#7c3aed]/50 bg-transparent group-hover:bg-[rgba(124,58,237,0.05)] transition-all duration-200 group-hover:border-[#a855f7] group-hover:scale-105"
                                style={{ backdropFilter: 'blur(8px)' }}
                            >
                                <img src={img} alt={label} className="size-7 object-contain" />
                            </span>
                            <span className="text-white/70 text-xs font-medium group-hover:text-white transition-colors">{label}</span>
                        </button>
                    ))}
                </div> */}
            </div>

            {/* ── Dashboard Stats Card ── */}
            <div className="relative z-10 px-4 max-w-[550px] mx-auto pt-6 pb-2">
                <div
                    className="rounded-2xl border border-[#2a1a42] overflow-hidden"
                    style={{ background: 'linear-gradient(160deg, #14092b 0%, #0e0620 100%)' }}
                >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 divide-x divide-[#2a1a42]">

                        {/* ── LEFT: Academy ── */}
                        <div
                            className="flex-[1.1] p-5 flex flex-col justify-between min-h-[260px] relative overflow-hidden group"
                            style={{ background: 'linear-gradient(135deg, #1f1433 0%, #0f0a1a 100%)' }}
                        >
                            {/* Background subtle effect */}
                            <div className="absolute -left-10 -top-10 size-40 bg-[#9770DD]/10 rounded-full blur-3xl group-hover:bg-[#9770DD]/20 transition-all duration-500"></div>

                            <div className="relative z-10 text-center mb-2">
                                <span className="text-white text-[16px] sm:text-[18px] font-bold tracking-wide">{t("dashboard.academy")}</span>
                            </div>

                            <div className="flex-1 flex items-center justify-center relative z-10 py-4">
                                <img
                                    src={PokedaoLogo}
                                    alt="Academy"
                                    className="w-full max-w-[160px] h-auto object-contain filter drop-shadow-[0_0_12px_rgba(255,255,255,0.15)] group-hover:scale-105 transition-transform duration-300"
                                />
                            </div>

                            <div className="relative z-10 mt-auto pt-2">
                                <button
                                    onClick={() => window.open('https://academy.tcg.zone', '_blank')}
                                    className="w-full py-2.5 px-4 border border-[#9770DD]/50 bg-[#9770DD]/10 rounded-full text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-[#9770DD]/20 transition-all shadow-[0_0_10px_rgba(151,112,221,0.2)]"
                                >
                                    <span>{t("dashboard.viewMore") || "View More"}</span> <FiChevronRight className="text-white text-xs" />
                                </button>
                            </div>
                        </div>

                        {/* ── RIGHT: Staking Rewards ── */}
                        <div className="flex-1 p-5 flex flex-col gap-3">
                            <p className="text-[#7c6a9a] text-[11px] font-semibold uppercase tracking-widest">
                                {t("dashboard.stakingReward") || "Staking Reward"}
                            </p>

                            {/* Mini stat cards — side by side like reference image */}
                            <div className="grid grid-cols-2 gap-2">
                                {/* Total Staked */}
                                <div className="rounded-lg p-3 border border-[#2a1a42] flex flex-col gap-2" style={{ background: 'rgba(124,58,237,0.1)' }}>
                                    <span className="size-8 rounded-xl flex items-center justify-center" style={{ background: 'rgba(124,58,237,0.3)' }}>
                                        <img src={Imgtotalstaked} alt="staked" className="size-5 object-contain" />
                                    </span>
                                    <div>
                                        <p className="text-[#7c6a9a] text-[12px] uppercase font-bold tracking-wider mb-1">{t("staking.title")}</p>
                                        <p className="text-white font-bold text-sm leading-none">
                                            {isLoadingUserROIAndCapLive
                                                ? <FiRotateCcw className="animate-spin inline" />
                                                : (userROIAndCapLive?.stakeAmount ?? "0.00")}
                                        </p>
                                        <p className="text-[#7c6a9a] text-[11px] mt-0.5">USDT</p>
                                    </div>
                                </div>

                                {/* Claimable */}
                                <div className="rounded-lg p-3 border border-[#2a1a42] flex flex-col gap-2" style={{ background: 'rgba(124,58,237,0.1)' }}>
                                    <span className="size-8 rounded-xl flex items-center justify-center" style={{ background: 'rgba(124,58,237,0.3)' }}>
                                        <img src={Imgclaimable} alt="claimable" className="size-5 object-contain" />
                                    </span>
                                    <div>
                                        <p className="text-[#7c6a9a] text-[12px] uppercase font-bold tracking-wider mb-0.5">{t("dashboard.claimable") || "Claimable"}</p>
                                        <p className="text-white font-bold text-sm leading-none">
                                            {isLoadingUserROIAndCapLive
                                                ? <FiRotateCcw className="animate-spin inline" />
                                                : (userROIAndCapLive?.confirmedTotal ?? "0.00")}
                                        </p>
                                        <p className="text-[#7c6a9a] text-[11px] mt-0.5">USDT</p>
                                    </div>
                                </div>
                            </div>

                            {/* Action buttons */}
                            <div className="flex flex-col gap-2 mt-auto">
                                <button
                                    type="button"
                                    onClick={() => navigate("/staking")}
                                    className="w-full flex items-center justify-between px-4 h-11 rounded-xl font-semibold text-sm text-white transition-all hover:opacity-90 active:scale-95"
                                    style={{ background: 'linear-gradient(90deg, #5b21b6 0%, #7c3aed 100%)', border: '1px solid rgba(167,139,250,0.35)' }}
                                >
                                    <span>{t("dashboard.claimReward") || "Claim Reward"}</span>
                                    <span className="size-6 rounded-full bg-white/20 flex items-center justify-center font-bold">›</span>
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate("/staking")}
                                    className="w-full flex items-center justify-between px-4 h-11 rounded-xl font-semibold text-sm text-white transition-all hover:opacity-90 active:scale-95"
                                    style={{ background: 'linear-gradient(90deg, #5b21b6 0%, #7c3aed 100%)', border: '1px solid rgba(167,139,250,0.35)' }}
                                >
                                    <span>{t("dashboard.stakeNow") || "Stake Now"}</span>
                                    <span className="size-6 rounded-full bg-white/20 flex items-center justify-center font-bold">›</span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ── Cards Section ── */}
            <div className="relative z-10 px-4 max-w-[550px] mx-auto pt-6 pb-4">

                {/* Premium Segmented Tabs */}
                <div className="flex bg-[#0f0a1a] p-1.5 rounded-2xl mb-6 border border-[#2a1a42] shadow-[0_4px_20px_rgba(0,0,0,0.4)] w-full max-w-[400px] mx-auto sm:mx-0">
                    <button
                        onClick={() => { setActiveTab("avault"); fetchVaultCards(); }}
                        className={`flex-1 px-6 py-2.5 text-sm font-bold rounded-xl transition-all duration-300 ${activeTab === "avault"
                            ? "bg-gradient-to-r from-[#9770DD]/30 to-[#9770DD]/10 text-white shadow-[0_0_15px_rgba(151,112,221,0.2)] border border-[#9770DD]/40"
                            : "text-[#7c6a9a] hover:text-white hover:bg-[#2a1a42]/30 border border-transparent"
                            }`}
                    >
                        {t("dashboard.avault")}
                    </button>
                    <button
                        onClick={() => { setActiveTab("myCards"); getUserPacks(); }}
                        className={`flex-1 px-6 py-2.5 text-sm font-bold rounded-xl transition-all duration-300 ${activeTab === "myCards"
                            ? "bg-gradient-to-r from-[#9770DD]/30 to-[#9770DD]/10 text-white shadow-[0_0_15px_rgba(151,112,221,0.2)] border border-[#9770DD]/40"
                            : "text-[#7c6a9a] hover:text-white hover:bg-[#2a1a42]/30 border border-transparent"
                            }`}
                    >
                        {t("dashboard.myCards")}
                    </button>
                </div>

                {/* Header */}
                <div className="flex items-center gap-3 mb-5">
                    <span
                        className="size-12 flex-shrink-0 flex items-center justify-center rounded-xl"
                    >
                        <img src={IconCardsProducts} alt="marketplace" className="size-7 object-contain" />
                    </span>
                    <div>
                        <h2 className="text-white font-semibold text-lg leading-none">
                            {activeTab === "avault" ? t("dashboard.avaultCards") : t("dashboard.allCards")}
                        </h2>
                        <p className="text-[#7c6a9a] text-sm mt-0.5">
                            {activeTab === "avault" ? (
                                totalVaultPages ? `${vaultCards.length} ${t("common.results")}` : ""
                            ) : (
                                `${UserPacks.length} ${t("common.results")}`
                            )}
                        </p>
                    </div>
                </div>

                {/* Card grid — 2 columns */}
                <div className="grid grid-cols-2 gap-3">
                    {activeTab === "avault" ? (
                        isLoadingVaultCards ? (
                            <div className="col-span-2 py-20 flex flex-col items-center justify-center gap-3">
                                <FiRotateCcw className="animate-spin text-[#7c3aed] text-4xl" />
                                <p className="text-[#7c6a9a] text-sm animate-pulse">{t('common.loading')}</p>
                            </div>
                        ) : vaultCards.length > 0 ? (
                            vaultCards.map((card, idx) => (
                                <div
                                    key={`vault-${card.nl_id || idx}`}
                                    onClick={() => navigate(`/vault/${card.nl_id}`)}
                                    className="bg-gray-950 rounded-2xl overflow-hidden flex flex-col border border-[#2a1a42] shadow-lg hover:shadow-[0_0_28px_rgba(124,58,237,0.5)] hover:border-[#7c3aed]/60 transition-all duration-300 cursor-pointer"
                                >
                                    {/* Card image */}
                                    <div className="w-full aspect-[3/4] flex items-center justify-center p-2 relative group">
                                        <img
                                            src={card.nl_image2 || card.nl_image3}
                                            alt={card.nl_name}
                                            className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-110"
                                        />
                                    </div>

                                    {/* Card info */}
                                    <div className="p-3 flex flex-col gap-2 flex-1">
                                        <p className="text-white font-extrabold text-xl leading-none">
                                            {formatUsd(card.nl_value)}
                                        </p>

                                        <p className="text-[#7c6a9a] text-[10px] font-semibold uppercase tracking-wider line-clamp-1">
                                            {card.nl_year || ""}
                                        </p>

                                        <p className="text-white text-xs font-semibold leading-snug line-clamp-2 min-h-[2rem]">
                                            {card.nl_name}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-span-2 py-20 text-center flex flex-col items-center gap-2">
                                <FiAlertCircle className="text-[#7c6a9a] text-3xl" />
                                <p className="text-[#7c6a9a] font-medium">{t("common.noData") || "No items found"}</p>
                            </div>
                        )
                    ) : (
                        isLoading ? (
                            <div className="col-span-2 py-20 flex flex-col items-center justify-center gap-3">
                                <FiRotateCcw className="animate-spin text-[#7c3aed] text-4xl" />
                                <p className="text-[#7c6a9a] text-sm animate-pulse">{t('common.loading')}</p>
                            </div>
                        ) : UserPacks.length > 0 ? (
                            UserPacks.map((card, idx) => (
                                <div key={`pack-${card.up_id || idx}`} className="bg-gray-950 rounded-2xl overflow-hidden flex flex-col border border-[#2a1a42] shadow-lg hover:shadow-[0_0_28px_rgba(124,58,237,0.5)] hover:border-[#7c3aed]/60 transition-all duration-300">
                                    {/* Card image */}
                                    <div className="w-full aspect-[3/4] flex items-center justify-center p-2 relative group">
                                        <img
                                            src={card.image}
                                            alt={card.name || "card"}
                                            className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-110"
                                        />
                                    </div>

                                    {/* Card info */}
                                    <div className="p-3 flex flex-col gap-2 flex-1">
                                        <p className="text-white font-extrabold text-xl leading-none">
                                            {card.fmv}
                                        </p>

                                        <p className="text-[#7c6a9a] text-[10px] font-semibold uppercase tracking-wider line-clamp-1">
                                            {card.packType}
                                        </p>

                                        <p className="text-white text-xs font-semibold leading-snug line-clamp-2 min-h-[2rem]">
                                            {card.name}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-span-2 py-20 text-center flex flex-col items-center gap-2">
                                <FiAlertCircle className="text-[#7c6a9a] text-3xl" />
                                <p className="text-[#7c6a9a] font-medium">{t("common.noData") || "No items found"}</p>
                            </div>
                        )
                    )}
                </div>

                {/* Pagination */}
                {activeTab === "avault" ? (
                    vaultCards.length > 0 && totalVaultPages > 1 && (
                        <div className="flex items-center justify-center gap-4 mt-8 mb-6">
                            <button
                                disabled={vaultPage === 1 || isLoadingVaultCards}
                                onClick={() => {
                                    setVaultPage(prev => Math.max(prev - 1, 1));
                                    window.scrollTo({ top: 1200, behavior: 'smooth' });
                                }}
                                className="size-10 rounded-full flex items-center justify-center border border-[#2a1a42] text-white disabled:opacity-20 transition-all hover:bg-[#7c3aed]/20 active:scale-90"
                            >
                                ←
                            </button>

                            <div className="flex items-center gap-1">
                                <span className="text-[#7c6a9a] text-xs uppercase tracking-widest font-bold">{t("common.page") || "Page"}</span>
                                <span className="text-white font-extrabold text-lg">{vaultPage}</span>
                                <span className="text-[#7c6a9a] text-xs font-bold">/</span>
                                <span className="text-[#7c6a9a] text-xs font-bold">{totalVaultPages}</span>
                            </div>

                            <button
                                disabled={vaultPage >= totalVaultPages || isLoadingVaultCards}
                                onClick={() => {
                                    setVaultPage(prev => prev + 1);
                                    window.scrollTo({ top: 1200, behavior: 'smooth' });
                                }}
                                className="size-10 rounded-full flex items-center justify-center border border-[#2a1a42] text-white disabled:opacity-20 transition-all hover:bg-[#7c3aed]/20 active:scale-90"
                            >
                                →
                            </button>
                        </div>
                    )
                ) : (
                    UserPacks.length > 0 && totalPages > 1 && (
                        <div className="flex items-center justify-center gap-4 mt-8 mb-6">
                            <button
                                disabled={page === 1 || isLoading}
                                onClick={() => {
                                    setPage(prev => Math.max(prev - 1, 1));
                                    window.scrollTo({ top: 1200, behavior: 'smooth' });
                                }}
                                className="size-10 rounded-full flex items-center justify-center border border-[#2a1a42] text-white disabled:opacity-20 transition-all hover:bg-[#7c3aed]/20 active:scale-90"
                            >
                                ←
                            </button>

                            <div className="flex items-center gap-1">
                                <span className="text-[#7c6a9a] text-xs uppercase tracking-widest font-bold">{t("common.page") || "Page"}</span>
                                <span className="text-white font-extrabold text-lg">{page}</span>
                                <span className="text-[#7c6a9a] text-xs font-bold">/</span>
                                <span className="text-[#7c6a9a] text-xs font-bold">{totalPages}</span>
                            </div>

                            <button
                                disabled={page >= totalPages || isLoading}
                                onClick={() => {
                                    setPage(prev => prev + 1);
                                    window.scrollTo({ top: 1200, behavior: 'smooth' });
                                }}
                                className="size-10 rounded-full flex items-center justify-center border border-[#2a1a42] text-white disabled:opacity-20 transition-all hover:bg-[#7c3aed]/20 active:scale-90"
                            >
                                →
                            </button>
                        </div>
                    )
                )}
            </div>

            {/* ── Quick Links Section ── */}
            <div className="relative z-10 px-4 max-w-[550px] mx-auto pt-2 pb-6">
                <div className="grid grid-cols-3 gap-3">
                    {/* Your Vault */}
                    <div className="bg-[#0f0a1a] border border-[#2a1a42] rounded-[20px] p-3 sm:p-4 flex flex-col h-[140px] sm:h-[160px]">
                        <div className="flex items-center justify-center gap-2 mb-4 shrink-0">
                            <FiArchive className="text-[#9770DD] text-base sm:text-lg shrink-0" />
                            <span className="text-white text-[11px] sm:text-[13px] font-bold truncate">{t("dashboard.yourVault") || "Your Vault"}</span>
                        </div>
                        <div className="flex-1 flex flex-col justify-end">
                            <div className="text-white text-sm sm:text-base font-medium mb-auto">
                                ${parseFloat(totalValue || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </div>
                            {/* <button
                                onClick={() => navigate('/community')}
                                className="w-full mt-3 py-1.5 px-3 border border-[#2a1a42] rounded-full text-white text-[11px] sm:text-xs flex items-center justify-between hover:bg-[#9770DD]/10 transition-colors"
                            >
                                <span>{t("common.view") || "View"}</span> <FiChevronRight className="text-gray-500 text-[10px]" />
                            </button> */}
                        </div>
                    </div>

                    {/* News */}
                    <div className="bg-[#0f0a1a] border border-[#2a1a42] rounded-[20px] p-3 sm:p-4 flex flex-col h-[140px] sm:h-[160px]">
                        <div className="flex items-center justify-center gap-2 mb-4 shrink-0">
                            <FiVolume2 className="text-[#9770DD] text-base sm:text-lg shrink-0" />
                            <span className="text-white text-[11px] sm:text-[13px] font-bold truncate">{t("dashboard.news") || "News"}</span>
                        </div>
                        <div className="flex-1 flex flex-col justify-end">
                            <div className="text-gray-300 text-[10px] sm:text-[11px] leading-tight mb-auto line-clamp-3 font-medium">
                                {t('dashboard.newMessage')}
                            </div>
                            <button
                                onClick={() => navigate('/news')}
                                // onClick={() => setShowAnnouncementModal(true)}
                                className="w-full mt-3 py-1.5 px-3 border border-[#2a1a42] rounded-full text-white text-[11px] sm:text-xs flex items-center justify-between hover:bg-[#9770DD]/10 transition-colors"
                            >
                                <span>{t("dashboard.viewMore") || "View"}</span> <FiChevronRight className="text-gray-500 text-[10px]" />
                            </button>
                        </div>
                    </div>

                    {/* Docs */}
                    <div className="bg-[#0f0a1a] border border-[#2a1a42] rounded-[20px] p-3 sm:p-4 flex flex-col h-[140px] sm:h-[160px]">
                        <div className="flex items-center justify-center gap-2 mb-4 shrink-0">
                            <FiFolder className="text-[#9770DD] text-base sm:text-lg shrink-0" />
                            <span className="text-white text-[11px] sm:text-[13px] font-bold truncate">{t("dashboard.docs") || "Docs"}</span>
                        </div>
                        <div className="flex-1 flex flex-col justify-end gap-3 mt-auto">
                            <button
                                onClick={() => window.open('https://pokedao.notion.site/', '_blank')}
                                className="w-full mt-3 py-1.5 px-3 border border-[#2a1a42] rounded-full text-white text-[11px] sm:text-xs flex items-center justify-between hover:bg-[#9770DD]/10 transition-colors"
                            >
                                <span>{t("dashboard.viewMore") || "View"}</span> <FiChevronRight className="text-gray-500 text-[10px]" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {showAnnouncementModal && currentAnnouncement && (
                <div className="fixed inset-0 bg-gray-950/75 backdrop-blur-sm flex items-center justify-center z-[70] p-4">
                    <div className="relative w-full max-w-md max-h-[82vh] overflow-hidden rounded-3xl bg-[#0b0611] border border-[#9770DD]/40 shadow-2xl shadow-[#9770DD]/25">
                        <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#5B36D9] via-[#A855F7] to-[#22C55E]" />
                        <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3 border-b border-[#231735]">
                            <div className="min-w-0">
                                <div className="flex items-center gap-2 text-[#DFD2FE] text-xs font-semibold uppercase tracking-[0.2em] mb-2">
                                    <FiAlertCircle className="size-4" />
                                    <span>{t("announcement") || "Announcement"}</span>
                                </div>
                                <h3 className="text-white text-lg font-semibold leading-snug break-words">
                                    {currentAnnouncement.ann_title}
                                </h3>
                                {currentAnnouncement.ann_pdate && (
                                    <p className="text-[#ad90cb] text-xs mt-1">{currentAnnouncement.ann_pdate}</p>
                                )}
                            </div>
                            <button
                                type="button"
                                onClick={() => setShowAnnouncementModal(false)}
                                className="flex-shrink-0 size-9 rounded-full bg-white/10 text-[#DFD2FE] hover:bg-white/20 transition-colors flex items-center justify-center"
                                aria-label="Close announcement"
                            >
                                <FiX className="size-5" />
                            </button>
                        </div>

                        <div className="px-5 py-4 max-h-[52vh] overflow-y-auto text-[#f4efff] text-sm leading-relaxed announcement-modal-content">
                            {currentAnnouncement.ann_file && (
                                <div className="mb-4 flex justify-center">
                                    <img
                                        src={currentAnnouncement.ann_file}
                                        alt={currentAnnouncement.ann_title || "Announcement"}
                                        className="rounded-2xl max-w-full h-auto object-contain"
                                    />
                                </div>
                            )}
                            {currentAnnouncement.ann_content ? (
                                <div
                                    className="space-y-3 [&_img]:rounded-2xl [&_img]:max-w-full [&_img]:h-auto [&_a]:text-[#B794F6] [&_p]:mb-3"
                                    dangerouslySetInnerHTML={{ __html: currentAnnouncement.ann_content }}
                                />
                            ) : (
                                !currentAnnouncement.ann_file && <p className="text-[#ad90cb]">No announcement content.</p>
                            )}
                        </div>

                        <div className="px-5 pb-5 pt-2 flex items-center gap-3">
                            {announcementList.length > 1 && (
                                <>
                                    <button
                                        type="button"
                                        onClick={showPreviousAnnouncement}
                                        className="flex-1 h-11 rounded-full border border-[#4d3168] text-[#DFD2FE] text-sm font-semibold hover:border-[#9770DD] transition-colors"
                                    >
                                        Prev
                                    </button>
                                    <div className="text-[#ad90cb] text-xs whitespace-nowrap">
                                        {currentAnnouncementIndex + 1}/{announcementList.length}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={showNextAnnouncement}
                                        className="flex-1 h-11 rounded-full border border-[#4d3168] text-[#DFD2FE] text-sm font-semibold hover:border-[#9770DD] transition-colors"
                                    >
                                        Next
                                    </button>
                                </>
                            )}
                            <button
                                type="button"
                                onClick={() => setShowAnnouncementModal(false)}
                                className="flex-[1.2] h-11 rounded-full bg-[#9770DD] text-white text-sm font-bold hover:bg-[#7a1fd6] transition-colors"
                            >
                                {t("dashboard.close") || "Close"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Referral Link Modal for TP Wallet */}
            {showReferralModal && (
                <div className="fixed inset-0 bg-gray-950 bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-auto">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-900">
                                {t("dashboard.copyReferralLink")}
                            </h3>
                            <button
                                onClick={closeReferralModal}
                                className="text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <FiX className="size-6" />
                            </button>
                        </div>

                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                {t("dashboard.referralLinkLabel")}
                            </label>
                            <div className="relative">
                                <input
                                    type="text"
                                    value={getReferralLink(account)}
                                    readOnly
                                    className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 text-sm text-gray-700 pr-12 referral-link"
                                    onClick={(e) => e.target.select()}
                                    autoFocus
                                />
                                <button
                                    onClick={copyFromModal}
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500 hover:text-blue-700 transition-colors"
                                    title={t("dashboard.copyToClipboard")}
                                >
                                    <FiCopy className="size-5" />
                                </button>
                            </div>
                        </div>

                        <div className="text-sm text-gray-600 mb-4">
                            {t("dashboard.tapToCopyInstruction")}
                        </div>

                        <div className="flex gap-3">
                            {/* <button
                                onClick={copyFromModal}
                                className="flex-1 bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                            >
                                {t("dashboard.copyLink")}
                            </button> */}
                            <button
                                onClick={closeReferralModal}
                                className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                            >
                                {t("dashboard.close")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
// import { useState, useEffect, useCallback, useRef } from "react";
// import {
//     FiPlusCircle,
//     FiCopy,
//     FiRotateCcw,
//     FiUnlock,
//     FiLock,
//     FiAlertCircle,
//     FiX,
//     FiRefreshCw,
//     FiExternalLink,
//     FiCheckCircle,
// } from "react-icons/fi";
// import { ethers } from "ethers";
// import { toast } from "react-hot-toast";
// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import NextfiIcon from "../images/icon-nextFi-reverse.svg";
// import Image01 from "../images/icon-assets-wallet.png";
// import Image02 from "../images/icon-performace.png";
// import JoinNextfi01 from "../images/img-join-001.png";
// import JoinNextfi02 from "../images/img-join-002.png";
// import JoinNextfi03 from "../images/img-join-003.png";
// import ArrowRight from "../images/arrow-right.png";
// import IconPurchaseTicket from "../images/purchase-ticket.png";
// import IconRedemption from "../images/icon-redemption.png";
// import IconRedemptionReverse from "../images/icon-redemption-reverse.png";
// import IconInvestment from "../images/icon-investment.png";
// import IconInvestmentReverse from "../images/icon-investment-reverse.png";
// import WalletIcon from "../images/tcg-icon-wallet.png";
// import DonationIcon from "../images/tcg-icon-donation-nft.png";
// import RewardIcon from "../images/tcg-icon-trophy.png";
// import ClaimRewardIcon from "../images/tcg-icon-claim-reward.png";
// import CommunityIcon from "../images/tcg-icon-community.png";
// import GoCommunityIcon from "../images/tcg-icon-go-community.png";
// import CommunityDonationFrame from "../images/community-donation-frame.png";
// import { useWallet } from "../hooks/useWallet";
// import { useRPCProvider } from "../hooks/useRPCProvider";
// import { CONTRACT_ADDRESSES, CONTRACT_ABIS, API_BASE } from "../constants/index";
// import { useTranslation } from "../hooks/useTranslation";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import { getTokenBySymbol } from "../tokens";

// const GET_BALANCE_API = `${API_BASE}/publicApi/getBalance`;
// const GET_TOTAL_STAKING_API = `${API_BASE}/publicApi/getTotalStaking`;
// const GET_TOTAL_DEPOSIT_API = `${API_BASE}/publicApi/getTotalDeposit`;
// const GET_ANNOUNCEMENT_LIST_API = `${API_BASE}/publicApi/getAnnList`;

// export default function Dashboard() {
//     const { t, language } = useTranslation();
//     const navigate = useNavigate();
//     const { account, isConnected, connectWallet, isCorrectNetwork } = useWallet();
//     const { executeWithFailover } = useRPCProvider();

//     // Extend dayjs with UTC plugin
//     dayjs.extend(utc);

//     const [depositAmount, setDepositAmount] = useState("0"); // deposit amount from backend getTotalDeposit
//     const [isLoadingGroupSales, setIsLoadingGroupSales] = useState(false);
//     const [currentTime, setCurrentTime] = useState(Date.now());
//     const [searchParams] = useSearchParams();
//     const [showReferralModal, setShowReferralModal] = useState(false);
//     const [userROIAndCapLive, setUserROIAndCapLive] = useState(null);
//     const [isLoadingUserROIAndCapLive, setIsLoadingUserROIAndCapLive] = useState(false);
//     const [announcementList, setAnnouncementList] = useState([]);
//     const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
//     const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);

//     // Restored state setters removed earlier (required by existing fetch/handler code)
//     const [groupSales, setGroupSales] = useState({ level: "S0", amount: "0" });
//     const [stakingData, setStakingData] = useState({
//         totalStaked: "0.00",
//         totalRewards: "0.00",
//         combined: "0.00",
//         activeStakes: 0,
//     });
//     const [topDownlines, setTopDownlines] = useState([]);
//     const [downlinesActiveCount, setDownlinesActiveCount] = useState(0);
//     const [usdtBalance, setUsdtBalance] = useState("0");
//     const [userTickets, setUserTickets] = useState([]);
//     const [isLoadingTickets, setIsLoadingTickets] = useState(false);
//     const [isLoadingUnstake, setIsLoadingUnstake] = useState(false);
//     const [isLoadingRestake, setIsLoadingRestake] = useState(false);
//     const [isReferralBound, setIsReferralBound] = useState(false);
//     const [userStakeRecords, setUserStakeRecords] = useState([]);
//     const [isLoadingStakeRecords, setIsLoadingStakeRecords] = useState(false);
//     const [isLoadingStaking, setIsLoadingStaking] = useState(false);
//     const [isTabSwitching, setIsTabSwitching] = useState(false);
//     const [activeTab, setActiveTab] = useState("tickets");
//     // Keep a ref to the latest account to avoid stale-closure issues
//     const accountRef = useRef(account);

//     // Ref to track abort controllers for cancelling ongoing requests
//     const abortControllersRef = useRef([]);

//     // Sync the ref whenever account changes
//     useEffect(() => {
//         accountRef.current = account;
//     }, [account]);

//     // Refs for accessing latest function references in intervals
//     const fetchFunctionsRef = useRef();

//     const fetchUserROIAndCapLive = useCallback(async () => {
//         if (!account || !isConnected || !isCorrectNetwork) {
//             return;
//         }

//         try {
//             setIsLoadingUserROIAndCapLive(true);
//             const { stakeAmount, confirmedTotal } = await executeWithFailover(async (provider) => {

//                 const stakingContract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.STAKING,
//                     CONTRACT_ABIS.STAKING,
//                     provider
//                 );

//                 const [
//                     roiAndCap,
//                     growthBonus,
//                     consensusBonus,
//                     confirmBaseMinusAmount,
//                     confirmActiveMinusAmount,
//                     growthBonusMinusAmount,
//                     consensusBonusMinusAmount
//                 ] = await Promise.all([
//                     stakingContract.getUserROIAndCapLive(account),
//                     stakingContract.userConfirmedGeneration(account),
//                     stakingContract.userConfirmedCommunity(account),
//                     stakingContract.userClaimedBaseROI(account),
//                     stakingContract.userClaimedActiveROI(account),
//                     stakingContract.userClaimedGeneration(account),
//                     stakingContract.userClaimedCommunity(account)
//                 ]);

//                 const {
//                     stakeAmount,
//                     confirmedBase,
//                     confirmedActive,
//                 } = roiAndCap;

//                 let newConfirmBaseAmount = confirmedBase;
//                 let newConfirmActiveAmount = confirmedActive;
//                 let newGrowthBonus = growthBonus;
//                 let newConsensusBonus = consensusBonus;

//                 if (confirmBaseMinusAmount > 0) {
//                     newConfirmBaseAmount = confirmedBase - confirmBaseMinusAmount;
//                 }
//                 if (confirmActiveMinusAmount > 0) {
//                     newConfirmActiveAmount = confirmedActive - confirmActiveMinusAmount;
//                 }

//                 if (growthBonusMinusAmount > 0) {
//                     newGrowthBonus = growthBonus - growthBonusMinusAmount;
//                 }
//                 if (consensusBonusMinusAmount > 0) {
//                     newConsensusBonus = consensusBonus - consensusBonusMinusAmount;
//                 }

//                 const total_active = newConfirmBaseAmount + newConfirmActiveAmount + newGrowthBonus + newConsensusBonus;

//                 return {
//                     stakeAmount: formatBonusAmount(stakeAmount),
//                     confirmedTotal: formatBonusAmount(total_active)
//                 };
//             });

//             setUserROIAndCapLive({
//                 "stakeAmount": stakeAmount,
//                 "confirmedTotal": confirmedTotal
//             });
//             setIsLoadingUserROIAndCapLive(false);
//         } catch (error) {
//             console.error("Error getting user ROI and cap live:", error);
//             // toast.error("Error getting user ROI and cap live: " + error.message);
//             setUserROIAndCapLive(null);
//         }

//     }, [account, isConnected, isCorrectNetwork, executeWithFailover]);

//     // Fetch group sales data
//     const fetchGroupSales = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount || !isConnected) {
//             setGroupSales({ level: "S0", amount: "0" });
//             return;
//         }

//         setIsLoadingGroupSales(true);
//         try {
//             const salesData = await executeWithFailover(async (provider) => {
//                 const stakingContract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.STAKING,
//                     CONTRACT_ABIS.STAKING,
//                     provider
//                 );

//                 // Get team KPI from contract
//                 const teamKpi = await stakingContract.getTeamKpi(currentAccount);
//                 const teamInvestValue = Number(teamKpi) / 10 ** 18;
//                 // Get team total investment value (in USDT)
//                 // const teamInvestValue =
//                 //     await stakingContract.teamTotalInvestValue(account);
//                 // const formattedAmount = ethers.formatUnits(teamInvestValue, 18);
//                 const amount = parseFloat(teamInvestValue).toFixed(18);
//                 // console.log(amount);
//                 // Determine level based on team investment value
//                 let level = "S1";
//                 const amountNum = parseFloat(amount);
//                 if (amountNum >= 100000000) {
//                     level = "S9";
//                 } else if (amountNum >= 50000000) {
//                     level = "S8";
//                 } else if (amountNum >= 10000000) {
//                     level = "S7";
//                 } else if (amountNum >= 5000000) {
//                     level = "S6";
//                 } else if (amountNum >= 1000000) {
//                     level = "S5";
//                 } else if (amountNum >= 500000) {
//                     level = "S4";
//                 } else if (amountNum >= 100000) {
//                     level = "S3";
//                 } else if (amountNum >= 50000) {
//                     level = "S2";
//                 } else if (amountNum >= 10000) {
//                     level = "S1";
//                 } else {
//                     level = "S0"; // Default for < 10,000
//                 }

//                 return { level, amount };
//             });

//             // Only update if account hasn't changed
//             if (currentAccount === accountRef.current) {
//                 setGroupSales(salesData);
//             }
//         } catch (error) {
//             console.error("Error fetching group sales:", error);
//             setGroupSales({ level: "S0", amount: "0" });
//         } finally {
//             // Only clear loading if account hasn't changed
//             if (currentAccount === accountRef.current) {
//                 setIsLoadingGroupSales(false);
//             }
//         }
//     }, [isConnected, executeWithFailover]);

//     // Fetch total staking from backend getTotalStaking (mg_member_order sum)
//     const fetchTotalStakingFromApi = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount || !isConnected) {
//             setStakingData((prev) => ({
//                 ...prev,
//                 totalStaked: "0.00",
//                 combined: prev.totalRewards || "0.00",
//             }));
//             return;
//         }

//         try {
//             const res = await fetch(GET_TOTAL_STAKING_API, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ userAddress: currentAccount }),
//             });
//             const data = await res.json().catch(() => ({}));
//             if (res.ok && data?.success) {
//                 const totalRaw = data.total ?? data.sum ?? 0;
//                 const totalNum = parseFloat(totalRaw) || 0;
//                 setStakingData((prev) => {
//                     const rewardsNum = parseFloat(prev.totalRewards || "0") || 0;
//                     const combinedNum = totalNum + rewardsNum;
//                     return {
//                         ...prev,
//                         totalStaked: totalNum.toFixed(2),
//                         combined: combinedNum.toFixed(2),
//                     };
//                 });
//             } else {
//                 setStakingData((prev) => ({
//                     ...prev,
//                     totalStaked: "0.00",
//                     combined: prev.totalRewards || "0.00",
//                 }));
//             }
//         } catch (e) {
//             console.warn("Error fetching total staking from API:", e);
//             setStakingData((prev) => ({
//                 ...prev,
//                 totalStaked: "0.00",
//                 combined: prev.totalRewards || "0.00",
//             }));
//         }
//     }, [isConnected]);

//     // Format Bonus amount (18 decimals) for display
//     const formatBonusAmount = useCallback((val) => {
//         if (val == null) return "0.00";
//         const raw = typeof val === "bigint" ? val.toString() : (val?.toString?.() ?? String(val ?? "0"));
//         const parsed = parseFloat(raw);
//         if (Number.isNaN(parsed)) return "0.00";
//         return (parsed / 1e18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     }, []);

//     // Fetch top 3 direct downlines by sales (Referral + Bonus contracts, same as Community)
//     const fetchTopDownlines = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount || !executeWithFailover) {
//             setTopDownlines([]);
//             setDownlinesActiveCount(0);
//             return;
//         }
//         try {
//             const { addresses, monthIdx } = await executeWithFailover(async (provider) => {
//                 const referralContract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.Referrals,
//                     CONTRACT_ABIS.REFERRAL,
//                     provider
//                 );
//                 const bonusContract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.Bonus,
//                     CONTRACT_ABIS.BONUS,
//                     provider
//                 );
//                 const count = await referralContract.getReferredUserCount(currentAccount);
//                 const n = typeof count === "bigint" ? Number(count) : (count?.toNumber?.() ?? Number(count)) || 0;
//                 const addrs = [];
//                 const ZERO = "0x0000000000000000000000000000000000000000";
//                 for (let i = 0; i < n; i++) {
//                     const addr = await referralContract.referredUsers(currentAccount, i);
//                     const a = addr && typeof addr === "string" ? addr : (addr?.toString?.() || String(addr));
//                     if (a && a.toLowerCase() !== ZERO.toLowerCase()) addrs.push(a);
//                 }
//                 const mi = await bonusContract.getCurrentMonthIndex().catch(() => 0);
//                 const monthIdx = typeof mi === "bigint" ? Number(mi) : (mi?.toNumber?.() ?? Number(mi)) ?? 0;
//                 return { addresses: addrs, monthIdx };
//             });
//             if (currentAccount !== accountRef.current) return;

//             const withSales = await Promise.all(
//                 (addresses || []).map(async (addr) => {
//                     let personalSales = 0n;
//                     let groupSalesVal = 0n;
//                     try {
//                         const [ps, gs] = await executeWithFailover(async (provider) => {
//                             const bonusContract = new ethers.Contract(
//                                 CONTRACT_ADDRESSES.Bonus,
//                                 CONTRACT_ABIS.BONUS,
//                                 provider
//                             );
//                             const [p, g] = await Promise.all([
//                                 bonusContract.getPersonalSales(addr, monthIdx),
//                                 bonusContract.getGroupSales(addr, monthIdx),
//                             ]);
//                             return [p, g];
//                         });
//                         personalSales = ps ?? 0n;
//                         groupSalesVal = gs ?? 0n;
//                     } catch (_) { }
//                     const pStr = formatBonusAmount(personalSales);
//                     const gStr = formatBonusAmount(groupSalesVal);
//                     const sum = parseFloat(pStr.replace(/,/g, "")) + parseFloat(gStr.replace(/,/g, ""));
//                     return {
//                         address: addr,
//                         displayName: `${addr.slice(0, 6)}...${addr.slice(-4)}`,
//                         contribution: sum.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
//                         sumNum: sum,
//                         active: sum > 0,
//                     };
//                 })
//             );
//             if (currentAccount !== accountRef.current) return;

//             const sorted = withSales.sort((a, b) => b.sumNum - a.sumNum);
//             const top3 = sorted.slice(0, 3);
//             const activeCount = sorted.filter((m) => m.sumNum > 0).length;

//             setTopDownlines(top3);
//             setDownlinesActiveCount(activeCount);
//         } catch (e) {
//             if (e?.code !== "CALL_EXCEPTION" && !e?.message?.includes("Wallet not detected")) {
//                 console.warn("fetchTopDownlines failed:", e);
//             }
//             setTopDownlines([]);
//             setDownlinesActiveCount(0);
//         }
//     }, [isConnected, executeWithFailover, formatBonusAmount]);

//     // Fetch USDT balance
//     const fetchUsdtBalance = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount || !isConnected) {
//             setUsdtBalance("0");
//             return;
//         }

//         try {
//             const usdtToken = getTokenBySymbol("USDT");
//             const balance = await executeWithFailover(async (provider) => {
//                 const contract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.USDT,
//                     CONTRACT_ABIS.USDT,
//                     provider
//                 );

//                 const balanceResult = await contract.balanceOf(currentAccount);
//                 const formattedBalance = ethers.formatUnits(
//                     balanceResult,
//                     usdtToken.decimals
//                 );
//                 return parseFloat(formattedBalance).toFixed(2);
//             });

//             if (currentAccount === accountRef.current) {
//                 setUsdtBalance(balance);
//             }
//         } catch (error) {
//             console.error("Error fetching USDT balance:", error);
//             if (currentAccount === accountRef.current) {
//                 setUsdtBalance("0");
//             }
//         }
//     }, [isConnected, executeWithFailover]);

//     // Fetch deposit amount from staking API (same as Staking page) for Total Balance card
//     const fetchDepositAmountFromApi = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount) {
//             setDepositAmount(null);
//             return;
//         }
//         try {
//             const res = await fetch(GET_TOTAL_DEPOSIT_API, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ userAddress: currentAccount }),
//             });
//             const data = await res.json().catch(() => ({}));
//             if (currentAccount !== accountRef.current) return;
//             if (res.ok && data != null) {
//                 const bal = data.total_deposit ?? "0.00";
//                 setDepositAmount(bal != null ? String(bal) : null);
//             } else {
//                 setDepositAmount(null);
//             }
//         } catch (e) {
//             if (accountRef.current === currentAccount) setDepositAmount(null);
//         }
//     }, []);

//     // Fetch group sales data

//     // Fetch user tickets
//     const fetchUserTickets = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount || !isConnected) {
//             setUserTickets([]);
//             return;
//         }

//         setIsLoadingTickets(true);
//         try {
//             const tickets = await executeWithFailover(async (provider) => {
//                 const ticketContract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.TICKETING,
//                     CONTRACT_ABIS.TICKET,
//                     provider
//                 );

//                 // Get user's tickets
//                 const ticketsResult = await ticketContract.getUsersTickets(
//                     currentAccount
//                 );

//                 // Format tickets data and sort by latest ID first
//                 return ticketsResult
//                     .map((ticket) => ({
//                         id: Number(ticket.id),
//                         validDay: Number(ticket.validDay),
//                         owner: ticket.owner,
//                         used: ticket.used,
//                     }))
//                     .sort((a, b) => b.id - a.id); // Sort by ID descending (latest first)
//             });

//             // Only update if account hasn't changed
//             if (currentAccount === accountRef.current) {
//                 setUserTickets(tickets);
//             }
//         } catch (error) {
//             console.error("Error fetching user tickets:", error);
//             setUserTickets([]);
//         } finally {
//             // Only clear loading if account hasn't changed
//             if (currentAccount === accountRef.current) {
//                 setIsLoadingTickets(false);
//             }
//         }
//     }, [isConnected, executeWithFailover]);

//     // Convert day index to date (returns UTC time)
//     const dayIndexToDate = (dayIndex) => {
//         const dayIndexNum = parseInt(dayIndex);

//         // If validDay is already a timestamp (large number), use it directly
//         if (dayIndexNum > 1000000000) {
//             return dayjs.unix(dayIndexNum).utc();
//         }

//         // If it's a small number, treat it as days since epoch
//         return dayjs.unix(dayIndexNum * 86400).utc();
//     };

//     // Get validity period (start and end dates) for a ticket
//     const getValidityPeriod = (ticket) => {
//         if (ticket.validDay) {
//             const validDate = dayIndexToDate(ticket.validDay);
//             // Convert to UTC+0
//             // Ticket is valid from 8:00 AM on start day to 8:00 AM on next day (24 hours)
//             const validDateUTC = validDate.utc();
//             const startTime = validDateUTC.hour(8).minute(0).second(0); // 8:00 AM UTC
//             const endTime = validDateUTC
//                 .add(1, "day")
//                 .hour(8)
//                 .minute(0)
//                 .second(0); // Next day 8:00 AM UTC

//             return {
//                 start: startTime,
//                 end: endTime,
//                 formatted: {
//                     start: startTime.utc().format("DD/MM/YY - hh:mm A"),
//                     end: endTime.utc().format("DD/MM/YY - hh:mm A"),
//                 },
//             };
//         }
//         return null;
//     };

//     // Check if ticket is expired
//     const isTicketExpired = (ticket) => {
//         if (ticket.validDay) {
//             const validityPeriod = getValidityPeriod(ticket);
//             if (validityPeriod) {
//                 const now = dayjs().utc(); // Current time in UTC+0
//                 // Ticket expires if current time is after the end time (8:00 AM next day UTC)
//                 return now.isAfter(validityPeriod.end);
//             }
//         }
//         return false;
//     };

//     // // Fetch user stake records
//     // const fetchUserStakeRecords = useCallback(async () => {
//     //     const currentAccount = accountRef.current;
//     //     if (!currentAccount || !isConnected) {
//     //         setUserStakeRecords([]);
//     //         return;
//     //     }

//     //     setIsLoadingStakeRecords(true);
//     //     try {
//     //         // Fetch stake count first
//     //         const totalStakes = await executeWithFailover(async (provider) => {
//     //             const stakingContract = new ethers.Contract(
//     //                 CONTRACT_ADDRESSES.STAKING,
//     //                 CONTRACT_ABIS.STAKING,
//     //                 provider
//     //             );
//     //             const stakeCountResult = await stakingContract.stakeCount(currentAccount);
//     //             return Number(stakeCountResult);
//     //         });

//     //         const stakeRecords = [];
//     //         const BATCH_SIZE = 10; // Process 10 stakes at a time

//     //         // Process stakes in batches to avoid timeout
//     //         for (let batchStart = 0; batchStart < totalStakes; batchStart += BATCH_SIZE) {
//     //             // Check if account changed during batch processing
//     //             if (currentAccount !== accountRef.current) {
//     //                 console.log("Account changed during stake record fetching, aborting");
//     //                 return;
//     //             }

//     //             const batchEnd = Math.min(batchStart + BATCH_SIZE, totalStakes);
//     //             const batchPromises = [];

//     //             // Create promises for this batch
//     //             for (let i = batchStart; i < batchEnd; i++) {
//     //                 const promise = executeWithFailover(async (provider) => {
//     //                     const stakingContract = new ethers.Contract(
//     //                         CONTRACT_ADDRESSES.STAKING,
//     //                         CONTRACT_ABIS.STAKING,
//     //                         provider
//     //                     );

//     //                     try {
//     //                         const stakeRecord = await stakingContract.userStakeRecord(currentAccount, i);
//     //                         const stakeTime = Number(stakeRecord[0]);
//     //                         const amount = stakeRecord[1];
//     //                         const status = stakeRecord[2];
//     //                         const stakeIndex = stakeRecord[3];
//     //                         const formattedAmount = ethers.formatUnits(amount, 18);

//     //                         // Get reward for this stake
//     //                         let reward = "0";
//     //                         try {
//     //                             const rewardResult = await stakingContract.rewardOfSlot(currentAccount, i);
//     //                             reward = ethers.formatUnits(rewardResult, 18);
//     //                         } catch (error) {
//     //                             console.warn(`Could not fetch reward for stake ${i}:`, error);
//     //                         }

//     //                         return {
//     //                             index: i,
//     //                             stakeTime,
//     //                             amount: parseFloat(formattedAmount).toFixed(2),
//     //                             status,
//     //                             stakeIndex: Number(stakeIndex),
//     //                             reward: parseFloat(reward).toFixed(2),
//     //                         };
//     //                     } catch (error) {
//     //                         console.warn(`Could not fetch stake record ${i}:`, error);
//     //                         return null;
//     //                     }
//     //                 });

//     //                 batchPromises.push(promise);
//     //             }

//     //             // Wait for this batch to complete
//     //             const batchResults = await Promise.all(batchPromises);

//     //             // Filter out null results and add to stakeRecords
//     //             stakeRecords.push(...batchResults.filter(record => record !== null));

//     //             // Update UI with partial results after each batch
//     //             if (currentAccount === accountRef.current && stakeRecords.length > 0) {
//     //                 setUserStakeRecords([...stakeRecords].sort((a, b) => b.stakeTime - a.stakeTime));
//     //             }
//     //         }

//     //         // Final update with sorted results
//     //         if (currentAccount === accountRef.current) {
//     //             setUserStakeRecords(stakeRecords.sort((a, b) => b.stakeTime - a.stakeTime));
//     //         }
//     //     } catch (error) {
//     //         console.error("Error fetching user stake records:", error);
//     //         setUserStakeRecords([]);
//     //     } finally {
//     //         // Only clear loading if account hasn't changed
//     //         if (currentAccount === accountRef.current) {
//     //             setIsLoadingStakeRecords(false);
//     //         }
//     //     }
//     // }, [isConnected, executeWithFailover]);

//     // Stake days options with rates

//     const getStakeDaysOptions = () => [
//         { days: 1, rate: 0.3, label: "1 Days - 0.3%", index: 0 },
//         { days: 7, rate: 1.0, label: "7 Days - 1%", index: 1 },
//         { days: 30, rate: 1.5, label: "30 Days - 1.5%", index: 2 },
//     ];

//     // Fetch referral binding status via Referral contract
//     const fetchReferralBindingStatus = useCallback(async () => {
//         const currentAccount = accountRef.current;
//         if (!currentAccount || !isConnected) {
//             setIsReferralBound(false);
//             return;
//         }

//         try {
//             const isBound = await executeWithFailover(async (provider) => {
//                 const referralContract = new ethers.Contract(
//                     CONTRACT_ADDRESSES.REFERRALS,
//                     CONTRACT_ABIS.REFERRALS,
//                     provider
//                 );
//                 const result = await referralContract.isBindReferral(currentAccount);
//                 return result;
//             });

//             if (currentAccount === accountRef.current) {
//                 setIsReferralBound(isBound);
//             }
//         } catch (error) {
//             console.error("Error fetching referral binding status:", error);
//             setIsReferralBound(false);
//         }
//     }, [isConnected, executeWithFailover]);

//     // Generate referral link. Accepts an optional address to avoid relying on stale state.
//     const getReferralLink = (addr) => {
//         const refAddress = addr || accountRef.current;
//         if (!refAddress) return "";
//         const baseUrl = window.location.origin;
//         return `${baseUrl}/dashboard?ref=${refAddress}`;
//     };

//     // Get wallet address for display
//     const getDisplayAddress = () => {
//         if (!account) return "";
//         return account;
//     };

//     // Copy referral link to clipboard (robust against timing/stale-account issues)
//     const copyReferralLink = async () => {
//         // Ensure we have a current account. If not, attempt to connect and wait briefly.
//         if (!accountRef.current) {
//             const connected = await connectWallet();
//             if (!connected) return; // user cancelled or connection failed

//             // Wait up to 5s for accountRef to populate (polling)
//             const start = Date.now();
//             while (!accountRef.current && Date.now() - start < 5000) {
//                 // small delay
//                 // eslint-disable-next-line no-await-in-loop
//                 await new Promise((r) => setTimeout(r, 100));
//             }

//             if (!accountRef.current) {
//                 toast.error(t("dashboard.referralLinkUnavailable"));
//                 return;
//             }
//         }

//         const link = getReferralLink(accountRef.current);
//         if (!link) return;

//         try {
//             if (navigator.clipboard && navigator.clipboard.writeText) {
//                 await navigator.clipboard.writeText(link);
//                 toast.success(t("dashboard.referralLinkCopied"));
//             } else {
//                 // Fallback: show prompt for manual copy
//                 prompt(t("header.copyFailed"), link);
//             }
//         } catch (err) {
//             console.error("Failed to copy referral link:", err);
//             // Final fallback
//             try {
//                 prompt(t("header.copyFailed"), link);
//             } catch (e) {
//                 // ignore
//             }
//         }
//     };

//     // Clear all data immediately when account changes (runs FIRST)
//     useEffect(() => {
//         // Cancel any ongoing fetch operations
//         abortControllersRef.current.forEach(controller => {
//             try {
//                 controller.abort();
//             } catch (e) {
//                 // Ignore abort errors
//             }
//         });
//         abortControllersRef.current = [];

//         // Clear all state immediately to prevent showing previous account's data
//         setUserTickets([]);
//         setUserStakeRecords([]);
//         setStakingData({
//             totalStaked: "0.00000",
//             totalRewards: "0.00000",
//             combined: "0.00000",
//             activeStakes: 0,
//         });
//         setGroupSales({ level: "S0", amount: "0" });
//         setIsReferralBound(false);

//         // Reset loading states to show fresh loading indicators
//         setIsLoadingTickets(false);
//         setIsLoadingStakeRecords(false);
//         setIsLoadingStaking(false);
//         setUsdtBalance("0");
//         setIsLoadingGroupSales(false);
//         setTopDownlines([]);
//         setDownlinesActiveCount(0);
//         setDepositAmount(null);
//     }, [account]); // Only depends on account - runs immediately when account changes

//     // Load staking data, group sales, tickets, stake records, and referral status (runs SECOND)
//     useEffect(() => {
//         if (accountRef.current && isConnected) {
//             // Small delay to ensure state is cleared first
//             const timer = setTimeout(() => {
//                 // fetchStakingData();
//                 fetchGroupSales();
//                 fetchTopDownlines();
//                 fetchUserTickets();
//                 fetchReferralBindingStatus();
//                 fetchUsdtBalance();
//                 fetchDepositAmountFromApi();
//                 fetchUserROIAndCapLive();
//             }, 100); // 100ms delay ensures state clearing happens first

//             return () => clearTimeout(timer);
//         }
//     }, [
//         isConnected,
//         // fetchStakingData,
//         fetchGroupSales,
//         fetchTopDownlines,
//         fetchUserTickets,
//         fetchDepositAmountFromApi,
//         fetchUserROIAndCapLive,
//         fetchReferralBindingStatus,
//         fetchUsdtBalance,
//     ]);

//     // Keep function references updated
//     useEffect(() => {
//         fetchFunctionsRef.current = {
//             // fetchStakingData,
//             fetchGroupSales,
//             fetchUsdtBalance,
//             fetchUserROIAndCapLive,
//             isLoadingUserROIAndCapLive,
//             isLoadingGroupSales,
//         };
//     });

//     // Store referral address from URL to localStorage (before wallet connection)
//     useEffect(() => {
//         const refAddress = searchParams.get("ref");

//         if (refAddress && ethers.isAddress(refAddress)) {
//             // Store referral address in localStorage for later use
//             localStorage.setItem("pendingReferralAddress", refAddress);
//         }
//     }, [searchParams]);

//     // Update current time every minute for countdown
//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentTime(Date.now());
//         }, 60000); // Update every minute

//         return () => clearInterval(interval);
//     }, []);

//     // Auto-refresh staking data and group sales every 5 seconds
//     useEffect(() => {
//         if (!accountRef.current || !isConnected) return;

//         let isMounted = true; // Track component mount status
//         let refreshInterval;
//         let consecutiveErrors = 0;
//         const maxErrors = 3;
//         const currentAccountAtStart = accountRef.current;

//         const safeRefresh = async () => {
//             // Check if component is still mounted and account hasn't changed
//             if (!isMounted || currentAccountAtStart !== accountRef.current) return;

//             const {
//                 fetchStakingData: currentFetchStaking,
//                 fetchGroupSales: currentFetchGroupSales,
//                 fetchUsdtBalance: currentFetchUsdtBalance,
//                 fetchUserROIAndCapLive: currentFetchUserROIAndCapLive,
//                 isLoadingStaking: currentLoadingStaking,
//                 isLoadingGroupSales: currentLoadingGroupSales,
//             } = fetchFunctionsRef.current || {};

//             // Skip if already loading or too many consecutive errors or functions not available
//             if (
//                 currentLoadingStaking ||
//                 currentLoadingGroupSales ||
//                 consecutiveErrors >= maxErrors ||
//                 !currentFetchStaking ||
//                 !currentFetchGroupSales ||
//                 !currentFetchUsdtBalance ||
//                 !currentFetchUserROIAndCapLive
//             ) {
//                 return;
//             }

//             try {
//                 // Use current function references to avoid stale closures
//                 await Promise.all([
//                     currentFetchStaking(),
//                     currentFetchGroupSales(),
//                     currentFetchUsdtBalance(),
//                     currentFetchUserROIAndCapLive(),
//                 ]);
//                 consecutiveErrors = 0; // Reset error counter on success
//             } catch (error) {
//                 consecutiveErrors++;
//                 console.warn(
//                     `Auto-refresh error (${consecutiveErrors}/${maxErrors}):`,
//                     error
//                 );

//                 // Stop auto-refresh after max errors to prevent spam
//                 if (consecutiveErrors >= maxErrors) {
//                     console.warn(
//                         "Auto-refresh disabled due to consecutive errors"
//                     );
//                     if (refreshInterval) {
//                         clearInterval(refreshInterval);
//                     }
//                 }
//             }
//         };

//         // Start interval
//         refreshInterval = setInterval(safeRefresh, 5000);

//         // Cleanup function
//         return () => {
//             isMounted = false;
//             if (refreshInterval) {
//                 clearInterval(refreshInterval);
//             }
//         };
//     }, [isConnected]); // Removed account and function dependencies - using accountRef instead

//     // Handle tab switch with loading
//     const handleTabSwitch = (tab) => {
//         setIsTabSwitching(true);
//         setActiveTab(tab);
//         // Simulate brief loading for smooth transition
//         setTimeout(() => {
//             setIsTabSwitching(false);
//         }, 300);
//     };

//     const promptReferralLink = async () => {
//         setShowReferralModal(true);
//     };

//     const closeReferralModal = async () => {
//         setShowReferralModal(false);
//     };

//     const copyFromModal = async () => {
//         const input = document.querySelector(".referral-link");
//         input.focus();
//         input.select();
//         document.execCommand("copy");
//         toast.success(t("dashboard.referralLinkCopied"));
//     };

//     return (
//         <div className="relative overflow-x-hidden -mx-4 -my-8 min-h-[calc(100vh-200px)]">
//             {/* Background gradient - darker purple at top/bottom, lighter in middle */}
//             {/*} <div className="absolute inset-0 bg-gradient-to-b from-[#0a0610] via-[#241630] to-[#0a0610] -z-10"></div>*/}

//             {/* Subtle geometric pattern overlay */}
//             {/*<div
//                 className="absolute inset-0 opacity-[0.03] pointer-events-none -z-10"
//                 style={{
//                     backgroundImage: `radial-gradient(circle at 2px 2px, #9770DD 1px, transparent 0)`,
//                     backgroundSize: '40px 40px'
//                 }}
//             ></div>*/}

//             {/* Additional pattern overlay for variety */}
//             {/*<div
//                 className="absolute inset-0 opacity-[0.02] pointer-events-none -z-10"
//                 style={{
//                     backgroundImage: `linear-gradient(45deg, transparent 48%, #9770DD 49%, #9770DD 51%, transparent 52%), linear-gradient(-45deg, transparent 48%, #9770DD 49%, #9770DD 51%, transparent 52%)`,
//                     backgroundSize: '60px 60px'
//                 }}
//             ></div>*/}

//             {/* Main Content - layout like reference image */}
//             <div className="relative z-10 pt-6 pb-6 px-4 max-w-md mx-auto space-y-5">
//                 {/* Total Balance Card - gradient, amount, % change, Deposit button */}
//                 <div className="rounded-3xl bg-gradient-to-b from-[#2d1b3d] to-[#0a0610] border border-[#9770DD]/30 p-6 shadow-lg shadow-[#9770DD]/15">
//                     <p className="text-center text-[#ad90cb] text-xs font-medium uppercase tracking-wider mb-2">
//                         {t("dashboard.totalDeposit") || "Total Deposit"}
//                     </p>
//                     <div className="text-center mb-2">
//                         <span className="text-white text-3xl font-bold align-top">$</span>
//                         <span className="text-white text-3xl font-bold">
//                             {isLoadingUserROIAndCapLive ? <FiRotateCcw className="animate-spin inline" /> : (userROIAndCapLive?.stakeAmount != "0" || userROIAndCapLive?.stakeAmount != null ? userROIAndCapLive?.stakeAmount : "0")}
//                         </span>
//                     </div>
//                     {/* <p className="text-center mb-6">
//                         <span className="text-emerald-400 text-sm font-medium">+2.45%</span>
//                         <span className="text-[#ad90cb] text-xs ml-1">{t("dashboard.last24h") || "last 24h"}</span>
//                     </p> */}
//                     {/* <button
//                         type="button"
//                         onClick={() => navigate("/deposit")}
//                         className="w-full h-12 rounded-full bg-white text-[#4F378B] font-semibold text-sm hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
//                     >
//                         <FiPlusCircle className="size-5" />
//                         {t("dashboard.depositFunds") || "Deposit Funds"}
//                     </button> */}
//                 </div>

//                 {/* Staking Rewards - title + two cards */}
//                 <div>
//                     <div className="flex items-center justify-between mb-3">
//                         <p className="text-[#ad90cb] text-xs font-medium uppercase tracking-wider">
//                             {t("dashboard.stakingRewards") || "Staking Rewards"}
//                         </p>
//                         <span className="material-symbols-outlined text-[#9770DD] text-xl">bolt</span>
//                     </div>
//                     <div className="grid grid-cols-2 gap-3">
//                         <div className="rounded-2xl bg-gradient-to-b from-[#2d1b3d] to-[#1a1023] border border-[#9770DD]/30 p-4 shadow-lg shadow-[#9770DD]/10">
//                             <p className="text-[#ad90cb] text-xs font-medium uppercase tracking-wider mb-1">
//                                 {t("dashboard.totalStaked") || "Total Staked"}
//                             </p>
//                             <p className="text-white text-xl font-bold">
//                                 {isLoadingUserROIAndCapLive ? <FiRotateCcw className="animate-spin inline" /> : (userROIAndCapLive?.stakeAmount != "0" || userROIAndCapLive?.stakeAmount != null ? userROIAndCapLive?.stakeAmount : "0")}
//                             </p>
//                             <p className="text-[#ad90cb] text-xs">USDT</p>
//                         </div>
//                         <div className="rounded-2xl bg-gradient-to-b from-[#2d1b3d] to-[#1a1023] border border-[#9770DD]/30 p-4 shadow-lg shadow-[#9770DD]/10">
//                             <p className="text-[#ad90cb] text-xs font-medium uppercase tracking-wider mb-1">
//                                 {t("dashboard.claimable") || "Claimable"}
//                             </p>
//                             <p className="text-white text-xl font-bold">
//                                 {isLoadingUserROIAndCapLive ? <FiRotateCcw className="animate-spin inline" /> : (userROIAndCapLive?.confirmedTotal != "0" && userROIAndCapLive?.confirmedTotal != null ? userROIAndCapLive?.confirmedTotal : "0")}
//                             </p>
//                             <p className="text-[#ad90cb] text-xs">USDT</p>
//                         </div>
//                     </div>
//                     <div className="mt-3 flex gap-2">
//                         <button
//                             type="button"
//                             onClick={() => navigate("/staking")}
//                             className="flex-1 h-10 rounded-full bg-[#9770DD]/20 border border-[#9770DD]/40 text-[#DFD2FE] text-sm font-semibold hover:bg-[#9770DD]/30 transition-colors"
//                         >
//                             {t("dashboard.staking") || "Staking"}
//                         </button>
//                         <button
//                             type="button"
//                             onClick={() => navigate("/staking")}
//                             className="flex-1 h-10 rounded-full bg-[#9770DD] text-white text-sm font-semibold hover:bg-[#7a1fd6] transition-colors"
//                         >
//                             {/* {t("dashboard.claimReward") || "Claim Reward"} */}
//                             {t("dashboard.detail") || "Detail"}
//                         </button>
//                     </div>
//                 </div>

//                 {/* Community Network - top 3 downlines by sales (contract), View All → community page */}
//                 {/* <div>
//                     <div className="flex items-center justify-between mb-3">
//                         <p className="text-[#ad90cb] text-xs font-medium uppercase tracking-wider">
//                             {t("dashboard.communityNetwork") || "Community Network"}
//                         </p>
//                         <span className="text-[#9770DD] text-xs font-medium">
//                             {downlinesActiveCount} {t("dashboard.active") || "Active"}
//                         </span>
//                     </div>
//                     <div className="rounded-2xl bg-[#1a1023]/80 border border-[#9770DD]/30 overflow-hidden shadow-lg shadow-[#9770DD]/10">
//                         {(
//                             topDownlines.length >= 3
//                                 ? topDownlines
//                                 : [
//                                     ...topDownlines,
//                                     ...Array.from({ length: 3 - topDownlines.length }, () => ({
//                                         address: null,
//                                         displayName: "—",
//                                         contribution: "0",
//                                         active: false,
//                                     })),
//                                 ]
//                         ).map((member, idx) => (
//                             <div
//                                 key={member.address || `placeholder-${idx}`}
//                                 className="flex items-center gap-3 px-4 py-3 border-b border-[#4d3168]/50 last:border-0"
//                             >
//                                 <div className="relative flex-shrink-0">
//                                     <div className="size-10 rounded-full bg-[#241630] border border-[#9770DD]/30 flex items-center justify-center text-[#ad90cb] text-sm font-medium">
//                                         {member.displayName === "—" ? "?" : member.displayName.slice(0, 1)}
//                                     </div>
//                                     <span className={`absolute bottom-0 right-0 size-2.5 rounded-full border-2 border-[#1a1023] ${member.active ? "bg-emerald-500" : "bg-gray-500"}`} />
//                                 </div>
//                                 <div className="flex-1 min-w-0">
//                                     <p className="text-white font-medium truncate">{member.displayName}</p>
//                                     <p className="text-[#ad90cb] text-xs">{t("dashboard.directDownline") || "Direct Downline"}</p>
//                                 </div>
//                                 <div className="text-right flex-shrink-0">
//                                     <p className="text-white font-medium">{member.contribution} USDT</p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                     <button
//                         type="button"
//                         onClick={() => navigate("/community")}
//                         className="w-full mt-3 h-12 rounded-full border-2 border-dashed border-[#4d3168] text-[#ad90cb] text-sm font-semibold uppercase tracking-wider hover:border-[#9770DD]/50 hover:text-[#DFD2FE] transition-colors"
//                     >
//                         {t("dashboard.viewAllNetwork") || "View All Network"}
//                     </button>
//                 </div> */}

//                 {/* Transaction History Section */}
//                 {/* <div className="rounded-3xl bg-[#1a1023]/70 backdrop-blur-md border border-[#9770DD]/30 p-5 shadow-lg shadow-[#9770DD]/15">
//                     <div className="flex items-center gap-3 mb-4">
//                         <span className="material-symbols-outlined text-gray-300 text-2xl" style={{ filter: 'drop-shadow(0 2px 4px rgba(255,255,255,0.3))' }}>
//                             receipt_long
//                         </span>
//                         <h3 className="text-lg font-semibold text-white">
//                             Transaction History
//                         </h3>
//                     </div>
//                     <div className="overflow-x-auto">
//                         <table className="w-full text-sm" style={{ minWidth: '450px', }}>
//                             <thead>
//                                 <tr className="border-b border-[#4d3168]">
//                                     <th className="sm:text-base text-[12px] text-left py-3 px-2 text-[#ad90cb] font-medium">
//                                         <div className="flex items-center gap-2">
//                                             <span className="material-symbols-outlined text-base">
//                                                 schedule
//                                             </span>
//                                             Date & Time
//                                         </div>
//                                     </th>
//                                     <th className="sm:text-base text-[12px] text-left py-3 px-2 text-[#ad90cb] font-medium">
//                                         <div className="flex items-center gap-2">
//                                             <span className="material-symbols-outlined text-base">
//                                                 person
//                                             </span>
//                                             Address
//                                         </div>
//                                     </th>
//                                     <th className="sm:text-base text-[12px] text-left py-3 px-2 text-[#ad90cb] font-medium">
//                                         <div className="flex items-center gap-2">
//                                             <span className="material-symbols-outlined text-base">
//                                                 lock
//                                             </span>
//                                             Amount
//                                         </div>
//                                     </th>
//                                     <th className="sm:text-base text-[12px] text-left py-3 px-2 text-[#ad90cb] font-medium">
//                                         <div className="flex items-center gap-2">
//                                             <span className="material-symbols-outlined text-base">
//                                                 check_circle
//                                             </span>
//                                             Progress
//                                         </div>
//                                     </th>
//                                 </tr>
//                             </thead>
//                             <tbody> */}
//                 {/* Transaction rows will go here */}
//                 {/* <tr>
//                                     <td colSpan="4" className="text-center py-8 text-[#ad90cb] text-sm">
//                                         No transactions yet
//                                     </td>
//                                 </tr>

//                             </tbody>
//                         </table>
//                     </div> */}
//                 {/* </div> */}
//             </div>


//             {/* Temporary Announcement Modal */}
//             {showAnnouncementModal && currentAnnouncement && (
//                 <div className="fixed inset-0 bg-gray-950/75 backdrop-blur-sm flex items-center justify-center z-[70] p-4">
//                     <div className="relative w-full max-w-md max-h-[82vh] overflow-hidden rounded-3xl bg-[#0b0611] border border-[#9770DD]/40 shadow-2xl shadow-[#9770DD]/25">
//                         <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#5B36D9] via-[#A855F7] to-[#22C55E]" />
//                         <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3 border-b border-[#231735]">
//                             <div className="min-w-0">
//                                 <div className="flex items-center gap-2 text-[#DFD2FE] text-xs font-semibold uppercase tracking-[0.2em] mb-2">
//                                     <FiAlertCircle className="size-4" />
//                                     <span>{t("announcement") || "Announcement"}</span>
//                                 </div>
//                                 <h3 className="text-white text-lg font-semibold leading-snug break-words">
//                                     {currentAnnouncement.ann_title}
//                                 </h3>
//                                 {currentAnnouncement.ann_pdate && (
//                                     <p className="text-[#ad90cb] text-xs mt-1">{currentAnnouncement.ann_pdate}</p>
//                                 )}
//                             </div>
//                             <button
//                                 type="button"
//                                 onClick={() => setShowAnnouncementModal(false)}
//                                 className="flex-shrink-0 size-9 rounded-full bg-white/10 text-[#DFD2FE] hover:bg-white/20 transition-colors flex items-center justify-center"
//                                 aria-label="Close announcement"
//                             >
//                                 <FiX className="size-5" />
//                             </button>
//                         </div>

//                         <div className="px-5 py-4 max-h-[52vh] overflow-y-auto text-[#f4efff] text-sm leading-relaxed announcement-modal-content">
//                             {currentAnnouncement.ann_file && (
//                                 <div className="mb-4 flex justify-center">
//                                     <img
//                                         src={currentAnnouncement.ann_file}
//                                         alt={currentAnnouncement.ann_title || "Announcement"}
//                                         className="rounded-2xl max-w-full h-auto object-contain"
//                                     />
//                                 </div>
//                             )}
//                             {currentAnnouncement.ann_content ? (
//                                 <div
//                                     className="space-y-3 [&_img]:rounded-2xl [&_img]:max-w-full [&_img]:h-auto [&_a]:text-[#B794F6] [&_p]:mb-3"
//                                     dangerouslySetInnerHTML={{ __html: currentAnnouncement.ann_content }}
//                                 />
//                             ) : (
//                                 !currentAnnouncement.ann_file && <p className="text-[#ad90cb]">No announcement content.</p>
//                             )}
//                         </div>

//                         <div className="px-5 pb-5 pt-2 flex items-center gap-3">
//                             {announcementList.length > 1 && (
//                                 <>
//                                     <button
//                                         type="button"
//                                         onClick={showPreviousAnnouncement}
//                                         className="flex-1 h-11 rounded-full border border-[#4d3168] text-[#DFD2FE] text-sm font-semibold hover:border-[#9770DD] transition-colors"
//                                     >
//                                         Prev
//                                     </button>
//                                     <div className="text-[#ad90cb] text-xs whitespace-nowrap">
//                                         {currentAnnouncementIndex + 1}/{announcementList.length}
//                                     </div>
//                                     <button
//                                         type="button"
//                                         onClick={showNextAnnouncement}
//                                         className="flex-1 h-11 rounded-full border border-[#4d3168] text-[#DFD2FE] text-sm font-semibold hover:border-[#9770DD] transition-colors"
//                                     >
//                                         Next
//                                     </button>
//                                 </>
//                             )}
//                             <button
//                                 type="button"
//                                 onClick={() => setShowAnnouncementModal(false)}
//                                 className="flex-[1.2] h-11 rounded-full bg-[#9770DD] text-white text-sm font-bold hover:bg-[#7a1fd6] transition-colors"
//                             >
//                                 {t("dashboard.close") || "Close"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Referral Link Modal for TP Wallet */}
//             {showReferralModal && (
//                 <div className="fixed inset-0 bg-gray-950 bg-opacity-50 flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-lg p-6 w-full max-w-md mx-auto">
//                         <div className="flex justify-between items-center mb-4">
//                             <h3 className="text-lg font-semibold text-gray-900">
//                                 {t("dashboard.copyReferralLink")}
//                             </h3>
//                             <button
//                                 onClick={closeReferralModal}
//                                 className="text-gray-400 hover:text-gray-600 transition-colors"
//                             >
//                                 <FiX className="size-6" />
//                             </button>
//                         </div>

//                         <div className="mb-4">
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 {t("dashboard.referralLinkLabel")}
//                             </label>
//                             <div className="relative">
//                                 <input
//                                     type="text"
//                                     value={getReferralLink(account)}
//                                     readOnly
//                                     className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 text-sm text-gray-700 pr-12 referral-link"
//                                     onClick={(e) => e.target.select()}
//                                     autoFocus
//                                 />
//                                 <button
//                                     onClick={copyFromModal}
//                                     className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500 hover:text-blue-700 transition-colors"
//                                     title={t("dashboard.copyToClipboard")}
//                                 >
//                                     <FiCopy className="size-5" />
//                                 </button>
//                             </div>
//                         </div>

//                         <div className="text-sm text-gray-600 mb-4">
//                             {t("dashboard.tapToCopyInstruction")}
//                         </div>

//                         <div className="flex gap-3">
//                             {/* <button
//                                 onClick={copyFromModal}
//                                 className="flex-1 bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition-colors font-medium"
//                             >
//                                 {t("dashboard.copyLink")}
//                             </button> */}
//                             <button
//                                 onClick={closeReferralModal}
//                                 className="flex-1 bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors font-medium"
//                             >
//                                 {t("dashboard.close")}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }
